
      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("eVK28", function(module, exports) {

var $1P2f3 = parcelRequire("1P2f3");



/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.10.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    'use strict';
    var ERROR = 'input is invalid type';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $1P2f3 === 'object' && $1P2f3.versions && $1P2f3.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'arrayBuffer'
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod('hex', is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = (parcelRequire("bH2ds"));
        var Buffer = (parcelRequire("bH2ds")).Buffer;
        var algorithm = is224 ? 'sha224' : 'sha256';
        var bufferFrom;
        if (Buffer.from && !root.JS_SHA256_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash(algorithm).update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod('hex', is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== 'string') {
            if (type === 'object') {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
            this.chromeBugWorkAround = true;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === 'string') {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === 'object') {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});

parcelRegister("zzZbq", function(module, exports) {
const $879361a9ede64ad7$export$82b05c69aac5d0c6 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $879361a9ede64ad7$export$e7d7da8c94dcb6fc = 'https://support.atlassian.com/confluence-cloud/docs/use-atlassian-intelligence-to-search-for-answers/';
const $879361a9ede64ad7$export$506bad4598ef877f = 'https://www.atlassian.com/software/artificial-intelligence';
const $879361a9ede64ad7$export$59da2b3b71a076c7 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $879361a9ede64ad7$export$b4efff19add55eb6 = 'https://confluence.atlassian.com/support/atlassian-support-ai-chat-1455423797.html';
const $879361a9ede64ad7$export$96cc4126cdc27248 = 'https://www.atlassian.com/legal/acceptable-use-policy';
const $879361a9ede64ad7$export$d3a50b0660f215e0 = 'https://support.atlassian.com/organization-administration/docs/usage-limits-in-atlassian-intelligence/';
const $879361a9ede64ad7$export$50e6b843de210064 = 'https://support.atlassian.com/organization-administration/docs/troubleshooting-for-atlassian-intelligence/';
const $879361a9ede64ad7$export$dd87179defae3659 = 'https://support.atlassian.com/organization-administration/docs/the-hipaa-implementation-guide/';
const $879361a9ede64ad7$export$2c1028e1e7bf5557 = 'https://www.atlassian.com/software/rovo';
const $879361a9ede64ad7$export$c4fda24479ad6357 = '82633dea-7fbf-4faa-9a51-a83a3fd181d9';
const $879361a9ede64ad7$export$91d63889268b5e23 = "365\xa05ce1d-16b8-4630-9e93-6c39069625fa";
const $879361a9ede64ad7$export$c0ced37cfe138d3e = '10f4daa4-bcfc-4d42-ae33-92888648d9db';
const $879361a9ede64ad7$export$d04cd98bb7625919 = 'customfield_10047';
const $879361a9ede64ad7$export$ed78826c06dd24e3 = 'fabric-elements';
var $879361a9ede64ad7$export$83c8d7110915321e = /*#__PURE__*/ function(SOURCE) {
    SOURCE["SEARCH_DIALOG"] = "searchDialog";
    SOURCE["ADVANCED_SEARCH"] = "advancedSearch";
    SOURCE["READING_AIDS"] = "readingAids";
    return SOURCE;
}({});
const $879361a9ede64ad7$export$e7862e8dbda0aa3 = '500px';
const $879361a9ede64ad7$export$169d09d6d83f61d6 = '/gateway/api/smartAnswers/stream';
const $879361a9ede64ad7$export$a00f71e6c6b44441 = '/gateway/api/assist';
const $879361a9ede64ad7$export$cc4a4ed360fef1ba = '/gateway/api/graphql';
var $879361a9ede64ad7$export$83d4ba88ba80625b = /*#__PURE__*/ function(QueryIntent) {
    QueryIntent["DEFAULT"] = "DEFAULT";
    QueryIntent["NATURAL_LANGUAGE_QUERY"] = "NATURAL_LANGUAGE_QUERY";
    QueryIntent["KEYWORD_OR_ACRONYM"] = "KEYWORD_OR_ACRONYM";
    QueryIntent["PERSON"] = "PERSON";
    QueryIntent["TEAM"] = "TEAM";
    QueryIntent["NAVIGATIONAL"] = "NAVIGATIONAL";
    QueryIntent["NONE"] = "NONE";
    QueryIntent["LOCATION"] = "LOCATION";
    QueryIntent["DATE"] = "DATE";
    QueryIntent["JIRA_ISSUE"] = "JIRA_ISSUE";
    QueryIntent["TOPIC"] = "TOPIC";
    QueryIntent["JIRA_NATURAL_LANGUAGE_QUERY"] = "JIRA_NATURAL_LANGUAGE_QUERY";
    QueryIntent["JIRA_NLQ_KEYWORD"] = "JIRA_NLQ_KEYWORD";
    QueryIntent["AGENT"] = "AGENT";
    QueryIntent["ORG_CHART"] = "ORG_CHART";
    QueryIntent["NAV_CONTENT"] = "NAV_CONTENT";
    QueryIntent["BOOKMARK"] = "BOOKMARK";
    QueryIntent["VISUAL"] = "VISUAL";
    return QueryIntent;
}({});
var $879361a9ede64ad7$export$a08a848abe54c31f = /*#__PURE__*/ function(AnswerCardType) {
    AnswerCardType["PERSON"] = "people";
    AnswerCardType["TEAM"] = "team";
    AnswerCardType["AGENT"] = "agent";
    AnswerCardType["DATE"] = "date";
    AnswerCardType["LOCATION"] = "location";
    AnswerCardType["TOPIC"] = "topic";
    AnswerCardType["JIRA_NATURAL_LANGUAGE_QUERY"] = "jira_nl_to_jql";
    AnswerCardType["JIRA_ISSUE"] = "jira_issue";
    AnswerCardType["NAVIGATIONAL"] = "navigational";
    AnswerCardType["NAV_CONTENT"] = "nav_content";
    AnswerCardType["NONE"] = "none";
    AnswerCardType["DEFAULT"] = "default";
    AnswerCardType["SAIN"] = "SAIN";
    AnswerCardType["DEFINITION"] = "definition";
    AnswerCardType["ORG_CHART"] = "org_chart";
    AnswerCardType["BOOKMARK_KNOWLEDGE_CARD"] = "bookmarkKnowledgeCard";
    AnswerCardType["VISUAL"] = "visual";
    return AnswerCardType;
}({});
var $879361a9ede64ad7$export$c243a7d908564b9b = /*#__PURE__*/ function(AiExperienceName) {
    AiExperienceName["PERSON_CARD"] = "Person Card";
    AiExperienceName["TEAM_CARD"] = "Team Card";
    AiExperienceName["LOCATION_CARD"] = "Location Card";
    AiExperienceName["DATE_CARD"] = "Date Card";
    AiExperienceName["TOPIC_CARD"] = "Topic Card";
    AiExperienceName["JIRA_NATURAL_LANGUAGE_QUERY_CARD"] = "Jira Card";
    AiExperienceName["AGENT_CARD"] = "Agent Card";
    AiExperienceName["JIRA_ISSUE_CARD"] = "Jira Issue Card";
    AiExperienceName["NAVIGATIONAL"] = "Navigational";
    AiExperienceName["NONE"] = "None";
    AiExperienceName["DEFAULT"] = "Default";
    AiExperienceName["PLAIN_TEXT"] = "Plain Text";
    AiExperienceName["POPULAR_SEARCH_QUERY_CARD"] = "Popular Search Query Card";
    AiExperienceName["NAVIGATIONAL_SEARCH_RESULT_CARD"] = "Navigational Search Result Card";
    return AiExperienceName;
}({});
var $879361a9ede64ad7$export$30e36b9f4147b88f = /*#__PURE__*/ function(CardTemplate) {
    CardTemplate["DEFAULT"] = "DEFAULT";
    CardTemplate["SMART_ANSWER"] = "SMART_ANSWER";
    CardTemplate["RIGHT_PANEL"] = "RIGHT_PANEL";
    return CardTemplate;
}({});
var $879361a9ede64ad7$export$49069087564847a7 = /*#__PURE__*/ function(AiBrand) {
    AiBrand["ROVO"] = "ROVO";
    AiBrand["AI"] = "ATLASSIAN INTELLIGENCE";
    return AiBrand;
}({});
var $879361a9ede64ad7$export$8375a80c95e07251 = /*#__PURE__*/ function(AIAnswerTab) {
    AIAnswerTab["AI_ANSWER"] = "AI_ANSWER";
    AIAnswerTab["SOURCES"] = "SOURCES";
    return AIAnswerTab;
}({});
const $879361a9ede64ad7$export$98d221c2fcca6d6b = [
    "AI_ANSWER",
    "SOURCES"
];
const $879361a9ede64ad7$export$7ecd7f1b620801eb = 'convo_ai_sain_prompt_override_hello';
const $879361a9ede64ad7$export$fe340b7aba57733d = 'atlassian.search-dialog.ai-answer-component';
module.exports["ATLASSIAN_INTELLIGENCE_SEARCH_INFO_LINK"] = $879361a9ede64ad7$export$e7d7da8c94dcb6fc;
module.exports["ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $879361a9ede64ad7$export$59da2b3b71a076c7;
module.exports["SAC_ATLASSIAN_INTELLIGENCE_TRUST_LINK"] = $879361a9ede64ad7$export$b4efff19add55eb6;
module.exports["ATLASSIAN_ACCEPTABLE_USE_POLICY_LINK"] = $879361a9ede64ad7$export$96cc4126cdc27248;
module.exports["ATLASSIAN_AI_USAGE_LIMITS_LINK"] = $879361a9ede64ad7$export$d3a50b0660f215e0;
module.exports["ATLASSIAN_AI_TROUBLESHOOT_LINK"] = $879361a9ede64ad7$export$50e6b843de210064;
module.exports["ATLASSIAN_HIPAA_COMPLICANCE_LINK"] = $879361a9ede64ad7$export$dd87179defae3659;
module.exports["ATLASSIAN_ROVO_LINK"] = $879361a9ede64ad7$export$2c1028e1e7bf5557;
module.exports["FEEDBACK_ENTRYPOINT_ID_SAIN"] = $879361a9ede64ad7$export$c4fda24479ad6357;
module.exports["FEEDBACK_ENTRYPOINT_ID_TOPICS"] = $879361a9ede64ad7$export$c0ced37cfe138d3e;
module.exports["FEEDBACK_CONTEXT_CF"] = $879361a9ede64ad7$export$d04cd98bb7625919;
module.exports["DEFAULT_GAS_CHANNEL"] = $879361a9ede64ad7$export$ed78826c06dd24e3;
module.exports["READING_AIDS_DIALOG_WIDTH"] = $879361a9ede64ad7$export$e7862e8dbda0aa3;
module.exports["SAIN_STREAMING_API"] = $879361a9ede64ad7$export$169d09d6d83f61d6;
module.exports["ASSISTANCE_SERVICE_API_BASE_URL"] = $879361a9ede64ad7$export$a00f71e6c6b44441;
module.exports["DEFAULT_GRAPHQL_ENDPOINT"] = $879361a9ede64ad7$export$cc4a4ed360fef1ba;
module.exports["QueryIntent"] = $879361a9ede64ad7$export$83d4ba88ba80625b;
module.exports["AnswerCardType"] = $879361a9ede64ad7$export$a08a848abe54c31f;
module.exports["AiExperienceName"] = $879361a9ede64ad7$export$c243a7d908564b9b;
module.exports["CardTemplate"] = $879361a9ede64ad7$export$30e36b9f4147b88f;
module.exports["AiBrand"] = $879361a9ede64ad7$export$49069087564847a7;
module.exports["AIAnswerTab"] = $879361a9ede64ad7$export$8375a80c95e07251;
module.exports["aiAnswerTabsOrder"] = $879361a9ede64ad7$export$98d221c2fcca6d6b;
module.exports["PROMPT_OVERRIDE_SESSION_KEY"] = $879361a9ede64ad7$export$7ecd7f1b620801eb;
module.exports["SEARCH_AI_ANSWER_CACHE_KEY"] = $879361a9ede64ad7$export$fe340b7aba57733d;

});

parcelRegister("7AtIp", function(module, exports) {
function $7a7ddad2b00bc2ae$export$14ef296862e3705e({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
}
module.exports["createAtlAttributionHeader"] = $7a7ddad2b00bc2ae$export$14ef296862e3705e;

});

parcelRegister("i5c0A", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $gABt9 = parcelRequire("gABt9");


var $cLhX4 = parcelRequire("cLhX4");


var $lbwuA = parcelRequire("lbwuA");

const $90c66dfb8e95b21f$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $90c66dfb8e95b21f$export$1642248503fca29({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $90c66dfb8e95b21f$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // Populated from HTTP response via requestService (not present on JSON body).
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName,
                // `operation` is added alongside `q` so UFO's Jira resource-timing
                // `sanitiseEndpoints` keys this fetch by its operation name (e.g.
                // KnowledgeDiscoveryIntentDetectionQuery) instead of collapsing it
                // into the anonymous `gateway_api_graphql` bucket.
                ...(0, $iDrrr.fg)('kd_fe_ufo_named_agg_resources') && {
                    operation: operationName
                }
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    // if there's a ttl use fetch with in-mem cacheing
    if (cache && (0, $iDrrr.fg)('kd_fe_enable_api_cache')) return (0, $lbwuA.fetchAggResponseWithCache)({
        graphQuery: graphQuery,
        variables: variables,
        operationName: operationName,
        cache: cache,
        headers: headers
    });
    const response = await (0, $gABt9.utils).requestService({
        url: url
    }, options);
    // Attach gateway trace / request IDs for downstream tracing and analytics.
    return (0, $cLhX4.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
}
module.exports["fetchAggResponse"] = $90c66dfb8e95b21f$export$1642248503fca29;

});

parcelRegister("cLhX4", function(module, exports) {
function $7e561b6b9ac47749$export$547fb2fa14d5b927(response, tracingHeaders) {
    if (!tracingHeaders || Object.keys(tracingHeaders).length === 0) return response;
    return {
        ...response,
        gatewayTracingHeaders: {
            ...response.gatewayTracingHeaders,
            ...tracingHeaders
        }
    };
}
module.exports["enrichAggResponseWithGatewayTracingHeaders"] = $7e561b6b9ac47749$export$547fb2fa14d5b927;

});

parcelRegister("lbwuA", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $gABt9 = parcelRequire("gABt9");


var $cLhX4 = parcelRequire("cLhX4");


var $jarkA = parcelRequire("jarkA");

const $f07e52544b73f9e1$var$DEFAULT_GRAPHQL_ENDPOINT = '/gateway/api/graphql';
async function $f07e52544b73f9e1$export$6fe550b7d5be614c({ graphQuery: graphQuery, variables: variables, operationName: operationName, aggAbsoluteUrl: url = $f07e52544b73f9e1$var$DEFAULT_GRAPHQL_ENDPOINT, cache: cache, headers: headers }) {
    // From HTTP response headers; merged onto the payload before cache / return.
    const capturedTracingHeaders = {};
    const options = {
        requestInit: {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers ? {
                    ...headers
                } : {}
            },
            body: JSON.stringify({
                operationName: operationName,
                query: graphQuery,
                variables: variables
            })
        },
        queryParams: {
            ...operationName && {
                q: operationName,
                // `operation` is added alongside `q` so UFO's Jira resource-timing
                // `sanitiseEndpoints` keys this fetch by its operation name (e.g.
                // KnowledgeDiscoveryIntentDetectionQuery) instead of collapsing it
                // into the anonymous `gateway_api_graphql` bucket.
                ...(0, $iDrrr.fg)('kd_fe_ufo_named_agg_resources') && {
                    operation: operationName
                }
            }
        },
        reportTracingHeaders: (tracing)=>{
            Object.assign(capturedTracingHeaders, tracing);
        }
    };
    let cachedResponse = (0, $jarkA.InMemCache).getData(cache.key);
    if (cachedResponse && (0, $jarkA.InMemCache).isValid(cache.key)) return Promise.resolve(cachedResponse);
    // return a pending promise that was cached earlier
    const inflightRequest = (0, $jarkA.InMemCache).getInflightRequest(cache.key);
    if (inflightRequest) return inflightRequest;
    // cache miss, fetch data from agg and store ref to promise
    const request = new Promise(async (resolve, reject)=>{
        try {
            const response = await (0, $gABt9.utils).requestService({
                url: url
            }, options);
            // Attach `x-trace-id` / `atl-request-id` from the HTTP layer for tracing.
            const enriched = (0, $cLhX4.enrichAggResponseWithGatewayTracingHeaders)(response, capturedTracingHeaders);
            (0, $jarkA.InMemCache).setData({
                key: cache.key,
                response: enriched,
                ttl: cache.ttl
            });
            resolve(enriched);
        } catch (error) {
            reject(error);
        } finally{
            (0, $jarkA.InMemCache).removeInflightRequest(cache.key);
        }
    });
    (0, $jarkA.InMemCache).setInflightRequest({
        key: cache.key,
        request: request
    });
    return request;
}
module.exports["fetchAggResponseWithCache"] = $f07e52544b73f9e1$export$6fe550b7d5be614c;

});

parcelRegister("jarkA", function(module, exports) {
const $3588e4a658fbd1e2$var$DEFAULT_TTL = 300000;
class $3588e4a658fbd1e2$export$916bab80494ce385 {
    static setData({ key: key, response: response, ttl: ttl }) {
        this.cache.set(key, {
            ttl: Date.now() + (ttl || $3588e4a658fbd1e2$var$DEFAULT_TTL),
            response: response
        });
    }
    static getData(key) {
        return this.cache.get(key)?.response;
    }
    static isValid(key) {
        const item = this.cache.get(key);
        return Boolean(item) && Date.now() < (item?.ttl || 0);
    }
    static getInflightRequest(key) {
        return this.inFlightRequests.get(key);
    }
    static setInflightRequest({ key: key, request: request }) {
        this.inFlightRequests.set(key, request);
    }
    static removeInflightRequest(key) {
        return this.inFlightRequests.delete(key);
    }
    // only for tests
    static clearCache() {
        this.cache.clear();
        this.inFlightRequests.clear();
    }
}
$3588e4a658fbd1e2$export$916bab80494ce385.cache = new Map();
$3588e4a658fbd1e2$export$916bab80494ce385.inFlightRequests = new Map();
module.exports["InMemCache"] = $3588e4a658fbd1e2$export$916bab80494ce385;

});

parcelRegister("iuy8J", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7XBGk = parcelRequire("7XBGk");


var $3hVWe = parcelRequire("3hVWe");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $hcBeC = parcelRequire("hcBeC");


var $u7MPJ = parcelRequire("u7MPJ");


var $W5g3o = parcelRequire("W5g3o");


var $ejlPj = parcelRequire("ejlPj");


var $j1YGG = parcelRequire("j1YGG");


var $97lMo = parcelRequire("97lMo");

const $83ed8089ae5bc973$var$i18n = (0, $kSwu1.defineMessages)({
    searchAiDialogQueryPretext: {
        id: "contextual-reading-aids.search-ai-dialog.query-pretext",
        defaultMessage: "what is {queryText}?"
    }
});
const $83ed8089ae5bc973$var$NO_CURATED_DEF_FOUND_MESSAGE = 'No matching scope for Definition';
const $83ed8089ae5bc973$export$7111b45b195dd101 = ({ workspaceId: workspaceId, cloudIdARI: cloudIdARI, fetchConfig: fetchConfig, isDefinitionCurationEnabled: isDefinitionCurationEnabled, productConfig: productConfig, product: product })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [loading, setLoading] = (0, $cozmU.useState)(true);
    const { fireAnalyticsEvent: fireAnalyticsEvent, commonAttributes: commonAttributes } = (0, $3hVWe.useAIAnswerContext)();
    const { contentId: contentId } = productConfig;
    const fetchAIGeneratedDefinition = (0, $cozmU.useCallback)(async ({ variables: variables })=>{
        const { query: query, locale: locale, additional_context: additional_context, experience: experience, followUpsEnabled: followUpsEnabled } = variables;
        if (contentId !== '') try {
            const precomputedResult = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: (0, $j1YGG.PrecomputedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    contentId: contentId
                },
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (precomputedResult.data && !precomputedResult.data.knowledgeDiscovery.autoDefinition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $97lMo.mapCustomDefinitionToNLPSearchType)(precomputedResult.data.knowledgeDiscovery.autoDefinition),
                        extraAPIAnalyticsAttributes: {
                            requestId: precomputedResult.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (precomputedResult.data && precomputedResult.data.knowledgeDiscovery.autoDefinition.message) throw new Error(precomputedResult.data.knowledgeDiscovery.autoDefinition.message);
            else throw new Error('Something went wrong with fetching precomputed definition');
        } catch (error) {
            if (error instanceof Object && 'message' in error && error.message !== $83ed8089ae5bc973$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $W5g3o.fetchPrecomputedDefinitionErrorPayload)(error, commonAttributes));
        }
        const streamFetchArgs = {
            variables: {
                query: intl.formatMessage($83ed8089ae5bc973$var$i18n.searchAiDialogQueryPretext, {
                    queryText: query
                }),
                locale: locale,
                cloudIdARI: cloudIdARI,
                additional_context: additional_context,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            },
            isReadingAids: true,
            fetchConfig: fetchConfig,
            generatorConfig: {
                yieldAnswerPart: true,
                yieldFinalResponse: true
            },
            onStreamFinalResponse: ()=>{
                setLoading(false);
            }
        };
        return {
            type: (0, $7XBGk.AIAnswerAPIType).STREAM,
            stream: (0, $hcBeC.aiDefinitionsStreamFetchConvoAIService)(streamFetchArgs)
        };
    }, [
        cloudIdARI,
        fetchConfig,
        intl,
        commonAttributes,
        fireAnalyticsEvent,
        workspaceId,
        contentId,
        product
    ]);
    const fetchDefinition = (0, $cozmU.useCallback)(async ({ variables: variables })=>{
        if (isDefinitionCurationEnabled) try {
            let confluenceScopeId, jiraScopeId;
            if ('spaceId' in productConfig) confluenceScopeId = productConfig;
            else if ('projectId' in productConfig) jiraScopeId = {
                projectId: productConfig.projectId
            };
            const result = await (0, $i5c0A.fetchAggResponse)({
                graphQuery: (0, $ejlPj.CuratedDefinitionQuery),
                variables: {
                    workspaceId: workspaceId,
                    keyPhrase: variables.query,
                    confluenceScopeId: confluenceScopeId,
                    jiraScopeId: jiraScopeId
                },
                operationName: (0, $ejlPj.CURATED_DEFINITION_OPERATION_NAME),
                headers: (0, $7AtIp.createAtlAttributionHeader)({
                    atlWorkspaceId: workspaceId,
                    tenantId: cloudIdARI,
                    product: product
                })
            });
            if (result.data && !result.data.knowledgeDiscovery.definition.message) {
                const data = {
                    nlpSearch: {
                        ...(0, $97lMo.mapCustomDefinitionToNLPSearchType)(result.data.knowledgeDiscovery.definition),
                        extraAPIAnalyticsAttributes: {
                            requestId: result.extensions?.gateway?.trace_id ?? null
                        }
                    }
                };
                setLoading(false);
                return data;
            } else if (result.data && result.data.knowledgeDiscovery.definition.message) throw new Error(result.data.knowledgeDiscovery.definition.message);
            else throw new Error('Something went wrong with fetching curated definition');
        } catch (error) {
            // want to fire event when error.message does not equal the no curated definition message
            // returned by the query in data.knowledgeDiscovery.definition.message
            if (error instanceof Object && 'message' in error && error.message !== $83ed8089ae5bc973$var$NO_CURATED_DEF_FOUND_MESSAGE) fireAnalyticsEvent((0, $u7MPJ.fetchCuratedDefinitionErrorPayload)(error, commonAttributes));
            return fetchAIGeneratedDefinition({
                variables: variables
            });
        }
        return fetchAIGeneratedDefinition({
            variables: variables
        });
    }, [
        productConfig,
        fetchAIGeneratedDefinition,
        isDefinitionCurationEnabled,
        workspaceId,
        commonAttributes,
        fireAnalyticsEvent,
        cloudIdARI,
        product
    ]);
    return {
        fetchDefinition: fetchDefinition,
        loading: loading
    };
};
module.exports["useDefinitionSupplier"] = $83ed8089ae5bc973$export$7111b45b195dd101;

});

parcelRegister("7XBGk", function(module, exports) {
var $077b30db84e7fa8f$export$e7b798431c659b80 = /*#__PURE__*/ function(AIAnswerAPIType) {
    AIAnswerAPIType["STREAM"] = "STREAM";
    return AIAnswerAPIType;
}({});
module.exports["AIAnswerAPIType"] = $077b30db84e7fa8f$export$e7b798431c659b80;

});

parcelRegister("3hVWe", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $zzZbq = parcelRequire("zzZbq");


var $eLxWr = parcelRequire("eLxWr");

const $3c43e73ca64de843$export$19a05d5f6391d0e1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createContext({
    loading: undefined,
    isAnswered: false,
    hasError: false,
    advancedSearchUrl: undefined,
    onNavigate: ()=>{},
    updateContextCache: ()=>{},
    fireAnalyticsEvent: ()=>{},
    setQuery: ()=>{},
    setData: ()=>{},
    userDetails: {},
    disclaimer: null,
    commonAttributes: (0, $eLxWr.UNINITIALIZED_COMMON_ATTRIBUTES),
    initialCollapsed: undefined,
    liked: undefined,
    setLiked: ()=>{},
    likesDisabled: false,
    setLikesDisabled: ()=>{},
    initialReported: undefined,
    isReadingAids: false,
    dynamicLayoutSubAgentMessages: [],
    setDynamicLayoutSubAgentMessages: ()=>{},
    cardProviderProps: undefined,
    baseQuery: undefined,
    smartAnswersRoute: (0, $zzZbq.QueryIntent).DEFAULT,
    cardTemplate: (0, $zzZbq.CardTemplate).DEFAULT,
    brand: (0, $zzZbq.AiBrand).AI,
    answerEditor: undefined,
    closeParentDialog: ()=>{},
    showGenericFooter: false,
    initiallyExpanded: false,
    queryIntentClassificationData: undefined,
    queryIntentDetectionMetadata: undefined,
    queryIntentDetectionTraceId: undefined,
    traceHeaders: undefined
});
const $3c43e73ca64de843$export$1485bfa2a4aa8c9b = ()=>{
    return (0, $cozmU.useContext)($3c43e73ca64de843$export$19a05d5f6391d0e1);
};
module.exports["AIAnswerContext"] = $3c43e73ca64de843$export$19a05d5f6391d0e1;
module.exports["useAIAnswerContext"] = $3c43e73ca64de843$export$1485bfa2a4aa8c9b;

});

parcelRegister("eLxWr", function(module, exports) {

var $zzZbq = parcelRequire("zzZbq");

const $8b6fc5e12c05b68e$export$fcf902966c0f8c2f = {
    cloudId: '',
    query: '',
    queryHash: '',
    baseQueryHash: '',
    source: '',
    searchSessionId: '',
    answerString: '',
    answerLength: 0,
    answerWordCount: 0,
    answerFormat: null,
    answerCardType: (0, $zzZbq.AnswerCardType).SAIN,
    sources: [],
    followUps: [],
    errorStateSuggestedQueries: [],
    errorState: null,
    extraAttributes: {},
    apiSource: 'cc-search-nlp',
    workspaceId: '',
    sessionId: '',
    brand: (0, $zzZbq.AiBrand).AI,
    orgId: '',
    isHello: false
};
module.exports["UNINITIALIZED_COMMON_ATTRIBUTES"] = $8b6fc5e12c05b68e$export$fcf902966c0f8c2f;

});

parcelRegister("hcBeC", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $6JEx2 = parcelRequire("6JEx2");


var $7zn5c = parcelRequire("7zn5c");


var $7s8U5 = parcelRequire("7s8U5");


var $kqQyU = parcelRequire("kqQyU");


var $htnqN = parcelRequire("htnqN");


var $hpFQM = parcelRequire("hpFQM");


var $cuvLu = parcelRequire("cuvLu");


var $7DMz5 = parcelRequire("7DMz5");


var $zzZbq = parcelRequire("zzZbq");


var $fn7C0 = parcelRequire("fn7C0");


var $EZPsO = parcelRequire("EZPsO");

const $90600a9a675bda6c$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
// Response headers that may carry a trace id we can use to correlate a failed
// request with backend/gateway (e.g. Stargate) logs. Checked in priority order.
const $90600a9a675bda6c$var$TRACE_ID_HEADERS = [
    'atl-traceid',
    'x-b3-traceid',
    'x-trace-id',
    'x-amzn-trace-id'
];
// Fallback used when we cannot (or are not allowed to) derive structured error
// details from the backend response.
const $90600a9a675bda6c$var$DEFAULT_BACKEND_ERROR_DETAILS = 'Unhandled error response received';
/**
 * Best-effort extraction of a trace id from the backend response headers so
 * that a failed request can be correlated with backend/gateway logs.
 */ function $90600a9a675bda6c$var$getTraceIdFromResponse(response) {
    try {
        for (const header of $90600a9a675bda6c$var$TRACE_ID_HEADERS){
            const value = response.headers?.get?.(header);
            if (value) return value;
        }
    } catch  {
    // Accessing headers should never throw, but guard defensively so error
    // handling never fails because of trace-id extraction.
    }
    return undefined;
}
/**
 * Best-effort read of the backend error response body, returning only
 * structured, allow-listed (non-UGC) details. Never throws.
 */ async function $90600a9a675bda6c$var$getStructuredErrorDetailsFromResponse(response) {
    try {
        return (0, $fn7C0.extractStructuredErrorDetails)(await response.text());
    } catch  {
        return undefined;
    }
}
/**
 * Build a non-UGC diagnostic `details` string for the "stream ended without a
 * valid FINAL_RESPONSE" case. Records what the backend actually sent as its last
 * message (the `type` discriminator) and, when the last message is an error
 * envelope, its allow-listed error key/status. Deliberately avoids recording any
 * free-form message text so no user-generated content is captured.
 */ function $90600a9a675bda6c$var$getNoFinalResponseDetails(lastMessage) {
    const receivedType = lastMessage && typeof lastMessage.type === 'string' ? lastMessage.type : 'undefined';
    let structured;
    try {
        structured = (0, $fn7C0.extractStructuredErrorDetails)(JSON.stringify(lastMessage));
    } catch  {
        structured = undefined;
    }
    return structured ? `No final response; received type: ${receivedType}; ${structured}` : `No final response; received type: ${receivedType}`;
}
function $90600a9a675bda6c$var$getAgentAndExperience(isReadingAids) {
    return isReadingAids ? {
        named_id: 'reading_aids_agent',
        experience: 'reading-aids'
    } : {
        named_id: 'sain_agent',
        experience: 'sain'
    };
}
function $90600a9a675bda6c$var$mapMimeTypeToFormat(mimeType) {
    switch(mimeType){
        case 'text/markdown':
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $hpFQM.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $hpFQM.NLPSearchResultFormat).JSON;
        default:
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
    }
}
function $90600a9a675bda6c$var$mapErrorToSain(error, traceId) {
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
}
function $90600a9a675bda6c$var$mapMessageToNLPSearchType(message, requestId) {
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message || message;
    return {
        nlpResult: messageContent.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $90600a9a675bda6c$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($90600a9a675bda6c$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : message.message?.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $iDrrr.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            cacheInfo: message.message?.message_metadata?.global_cache_info ?? null,
            pluginInvocations: message.message?.plugin_invocations,
            rawJson: message,
            ...(0, $iDrrr.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            }
        },
        authority_ui_metadata: messageContent.authority_ui_metadata ?? null
    };
}
async function* $90600a9a675bda6c$export$87d234127b4babfd({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig }) {
    try {
        const { query: query, locale: locale, experience: experience, filters: filters, cloudIdARI: cloudIdARI, followUpsEnabled: followUpsEnabled } = variables || {};
        const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.SAIN_STREAMING_API)}`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: query,
                filters: filters,
                locations: [
                    cloudIdARI
                ],
                locale: locale,
                experience: experience,
                followUpsEnabled: followUpsEnabled
            }),
            credentials: fetchConfig?.credentials || 'same-origin'
        }));
        if (!response.ok) {
            // For non 200 status codes. When enabled, record structured, non-UGC
            // details (error key/status) and a trace id so upstream failures (e.g.
            // Stargate 404 FAILURE_CLIENT_TCS) are diagnosable. The full body stays
            // retrievable from backend/gateway logs via the trace id.
            const captureBackendErrorDetails = (0, $iDrrr.fg)('kd_sain_capture_backend_error_details');
            const traceId = captureBackendErrorDetails ? $90600a9a675bda6c$var$getTraceIdFromResponse(response) : undefined;
            const details = captureBackendErrorDetails ? await $90600a9a675bda6c$var$getStructuredErrorDetailsFromResponse(response) ?? $90600a9a675bda6c$var$DEFAULT_BACKEND_ERROR_DETAILS : $90600a9a675bda6c$var$DEFAULT_BACKEND_ERROR_DETAILS;
            return {
                state: 'failed',
                reason: 'backend',
                details: details,
                errorCode: response.status,
                traceId: traceId
            };
        }
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            traceId: (0, $iDrrr.fg)('kd_sain_capture_backend_error_details') ? $90600a9a675bda6c$var$getTraceIdFromResponse(response) : undefined
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) yield parsedData;
                    else {
                        finalResponse = parsedData;
                        done = true;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) {
                // The stream ended without a valid FINAL_RESPONSE. This is not a
                // parse failure - it usually means an upstream error (e.g. Stargate
                // returning a non-2xx such as 404 FAILURE_CLIENT_TCS) short-circuited
                // the stream so the backend never emitted a final response body.
                // Capture non-UGC diagnostics (the type we actually received and, when
                // enabled, the trace id) so this failure is diagnosable if it recurs.
                const captureNoFinalResponseDetails = (0, $iDrrr.fg)('kd_sain_capture_backend_error_details');
                return {
                    state: 'failed',
                    reason: 'no_final_response',
                    error: 'Unexpected final response value',
                    details: captureNoFinalResponseDetails ? $90600a9a675bda6c$var$getNoFinalResponseDetails(finalResponse) : undefined,
                    traceId: captureNoFinalResponseDetails ? $90600a9a675bda6c$var$getTraceIdFromResponse(response) : undefined
                };
            }
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') // this is likely an abort error
        return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
const $90600a9a675bda6c$var$getAgentInput = ({ variables: variables, fetchConfig: fetchConfig })=>{
    const { query: query, locale: locale, additional_context: additional_context, experimentContext: experimentContext, isQuerySuggestion: isQuerySuggestion } = variables || {};
    return {
        content: query,
        locale: locale,
        additional_context: additional_context,
        entity_ari: fetchConfig?.entity_ari,
        ...experimentContext && (0, $iDrrr.fg)('kd_sain_backend_exp_context') && {
            experimentContext: experimentContext
        },
        ...typeof isQuerySuggestion === 'boolean' ? {
            isQuerySuggestion: isQuerySuggestion
        } : {}
    };
};
const $90600a9a675bda6c$var$getPromptOverrideContext = ()=>{
    if (!(0, $iDrrr.fg)('convo_ai_sain_enable_prompt_override_hello_only')) return {};
    const promptOverride = (0, $6JEx2.getSessionItem)((0, $zzZbq.PROMPT_OVERRIDE_SESSION_KEY));
    if (!promptOverride) return {};
    return {
        aiFeatureContext: {
            systemPromptOverride: promptOverride
        }
    };
};
async function* $90600a9a675bda6c$export$3e1bd964ad0ba888({ fetchReturn: fetchReturn, variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, storeMessage: storeMessage, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const { filters: filters, selectedProduct: selectedProduct } = variables || {};
        const { experience: experience, named_id: named_id } = $90600a9a675bda6c$var$getAgentAndExperience(isReadingAids);
        const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/sain/stream`;
        const streamFilters = filters && !Array.isArray(filters) && (0, $iDrrr.fg)('kd_add_common_filters_support_to_sain') ? [
            {
                commonFilters: filters.commonFilters
            },
            {
                confluenceFilters: filters.confluenceFilters
            }
        ] : [
            {
                confluenceFilters: filters
            }
        ];
        if (selectedProduct) streamFilters.push({
            knowledgeSources: [
                selectedProduct
            ]
        });
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': experience,
                'X-Rovo-Chat-Capabilities': JSON.stringify([
                    'inline_lumina_enabled'
                ]),
                ...((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled()) && {
                    'X-Think-Deeper-Messages-Opt-In': 'true',
                    'X-New-Tool-Traces-Opt-In': 'true'
                },
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                recipient_agent_named_id: named_id,
                agent_input: {
                    ...$90600a9a675bda6c$var$getAgentInput({
                        variables: variables,
                        fetchConfig: fetchConfig
                    }),
                    filters: filters ? streamFilters : undefined,
                    ...$90600a9a675bda6c$var$getPromptOverrideContext()
                },
                ...storeMessage
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = (0, $iDrrr.fg)('kd_sain_capture_backend_error_details') ? $90600a9a675bda6c$var$getTraceIdFromResponse(response) ?? null : response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body',
            traceId: traceId ?? undefined
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            const pluginsInvoked = [];
            yield {
                type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    // For non 200 status codes. When enabled, record structured, non-UGC
                    // details (error key/status) plus trace id; otherwise fall back to a
                    // generic string. Full body remains retrievable from logs via trace id.
                    return (0, $iDrrr.fg)('kd_sain_capture_backend_error_details') ? {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $fn7C0.extractStructuredErrorDetails)(lines[0]) ?? $90600a9a675bda6c$var$DEFAULT_BACKEND_ERROR_DETAILS,
                        errorCode: response.status,
                        backendFailureType: 'http_error',
                        traceId: traceId ?? undefined
                    } : {
                        state: 'failed',
                        reason: 'backend',
                        details: $90600a9a675bda6c$var$DEFAULT_BACKEND_ERROR_DETAILS,
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $EZPsO.mapStreamSAINResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === 'plugin-invocation') {
                        pluginsInvoked.push(parsedData.pluginName);
                        continue;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).EarlyStop) return {
                        state: 'complete',
                        value: parsedData
                    };
                    else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) {
                // The stream ended without a valid FINAL_RESPONSE. This is not a
                // parse failure - it usually means an upstream error (e.g. Stargate
                // returning a non-2xx such as 404 FAILURE_CLIENT_TCS) short-circuited
                // the stream so the backend never emitted a final response body.
                const captureNoFinalResponseDetails = (0, $iDrrr.fg)('kd_sain_capture_backend_error_details');
                return {
                    state: 'failed',
                    reason: 'no_final_response',
                    error: 'Unexpected final response value',
                    details: captureNoFinalResponseDetails ? $90600a9a675bda6c$var$getNoFinalResponseDetails(finalResponse) : undefined,
                    traceId: captureNoFinalResponseDetails ? traceId ?? undefined : undefined
                };
            }
            if ((0, $iDrrr.fg)('kd_add_plugins_invoked')) {
                const filteredPluginsInvoked = pluginsInvoked.filter(Boolean);
                if (filteredPluginsInvoked.length > 0 && finalResponse.message) {
                    const existing = finalResponse.message.extraAPIAnalyticsAttributes?.pluginsInvoked ?? [];
                    finalResponse.message.extraAPIAnalyticsAttributes = {
                        ...finalResponse.message.extraAPIAnalyticsAttributes,
                        pluginsInvoked: [
                            ...new Set([
                                ...existing,
                                ...filteredPluginsInvoked
                            ])
                        ]
                    };
                }
            }
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
async function $90600a9a675bda6c$export$c8ae4e2310d6c222({ variables: variables, isReadingAids: isReadingAids, fetchConfig: fetchConfig }) {
    const { experience: experience, named_id: named_id } = $90600a9a675bda6c$var$getAgentAndExperience(isReadingAids);
    const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}/chat/v1/invoke_agent`;
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Product': 'confluence',
            'X-Experience-Id': experience,
            ...fetchConfig?.headers
        },
        body: JSON.stringify({
            recipient_agent_named_id: named_id,
            agent_input: $90600a9a675bda6c$var$getAgentInput({
                variables: variables,
                fetchConfig: fetchConfig
            })
        }),
        credentials: fetchConfig?.credentials || 'same-origin',
        signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
    });
    // When enabled, use the broadened multi-header trace-id extraction; otherwise
    // fall back to the original single-header behavior.
    const traceId = (0, $iDrrr.fg)('kd_sain_capture_backend_error_details') ? $90600a9a675bda6c$var$getTraceIdFromResponse(response) ?? null : response.headers.get('x-trace-id') || null;
    const data = await response.json();
    if ('message_template' in data) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $90600a9a675bda6c$var$mapErrorToSain(data, traceId);
        return {
            nlpSearch: {
                errorState: errorState,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    return {
        nlpSearch: $90600a9a675bda6c$var$mapMessageToNLPSearchType(data, traceId)
    };
}
async function* $90600a9a675bda6c$export$824b789d24de77d3({ fetchReturn: fetchReturn, variables: variables, fetchConfig: fetchConfig, generatorConfig: generatorConfig = {
    yieldAnswerPart: true,
    yieldFinalResponse: false
}, onStreamFinalResponse: onStreamFinalResponse }) {
    try {
        const url = `${fetchConfig?.hostName || ''}${(0, $zzZbq.ASSISTANCE_SERVICE_API_BASE_URL)}/rovo/v1/ai-definition`;
        const response = await (fetchReturn ? fetchReturn : fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': 'confluence',
                'X-Experience-Id': 'reading-aids',
                ...fetchConfig?.headers ? fetchConfig.headers : {}
            },
            body: JSON.stringify({
                ...$90600a9a675bda6c$var$getAgentInput({
                    variables: variables,
                    fetchConfig: fetchConfig
                })
            }),
            credentials: fetchConfig?.credentials || 'same-origin',
            signal: fetchConfig?.timeout ? AbortSignal.timeout(fetchConfig?.timeout) : undefined
        }));
        const traceId = (0, $iDrrr.fg)('kd_sain_capture_backend_error_details') ? $90600a9a675bda6c$var$getTraceIdFromResponse(response) ?? null : response.headers.get('x-trace-id') || null;
        if (!response.body) return {
            state: 'failed',
            reason: 'backend',
            details: 'response.body missing',
            errorCode: response.status,
            backendFailureType: 'empty_body',
            traceId: traceId ?? undefined
        };
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            let finalResponse;
            yield {
                type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerType,
                message: {
                    format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN
                }
            };
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // add case here to return error from stream
                if (!response.ok) {
                    const finalResponse = JSON.parse(lines[0]);
                    if (finalResponse?.errors.includes((0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR)) return {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $kqQyU.NLPSearchErrorCodes).HIPAA_ENABLED_ERROR,
                        errorCode: response.status,
                        backendFailureType: 'hipaa'
                    };
                    // For non 200 status codes. When enabled, record structured, non-UGC
                    // details (error key/status) plus trace id; otherwise fall back to a
                    // generic string. Full body remains retrievable from logs via trace id.
                    return (0, $iDrrr.fg)('kd_sain_capture_backend_error_details') ? {
                        state: 'failed',
                        reason: 'backend',
                        details: (0, $fn7C0.extractStructuredErrorDetails)(lines[0]) ?? $90600a9a675bda6c$var$DEFAULT_BACKEND_ERROR_DETAILS,
                        errorCode: response.status,
                        backendFailureType: 'http_error',
                        traceId: traceId ?? undefined
                    } : {
                        state: 'failed',
                        reason: 'backend',
                        details: $90600a9a675bda6c$var$DEFAULT_BACKEND_ERROR_DETAILS,
                        errorCode: response.status,
                        backendFailureType: 'http_error'
                    };
                }
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = (0, $EZPsO.mapStreamDefinitionResponse)(JSON.parse(line), traceId);
                    if (parsedData.type === 'other') continue;
                    else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).GenerationType || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).Trace || parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage) {
                        if (generatorConfig.yieldAnswerPart) yield parsedData;
                    } else if (parsedData.type === 'follow-up') {
                        if (!finalResponse?.message || !variables?.followUpsEnabled) continue;
                        finalResponse.message.nlpFollowUpResults = {
                            followUps: parsedData.queries
                        };
                        const { serveExperiment: serveErrorStateSuggestedQueriesExp } = (0, $7zn5c.getFrontendExperiment)({
                            abTestId: 'kd_sain_show_no_answer_suggestions_exp'
                        });
                        if (!serveErrorStateSuggestedQueriesExp) done = true;
                    } else if (parsedData.type === (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions) {
                        if (!finalResponse?.message) continue;
                        finalResponse.message.nlpSuggestedQueries = parsedData.suggested_queries;
                        done = true;
                    } else {
                        finalResponse = parsedData;
                        onStreamFinalResponse?.();
                        if (!variables?.followUpsEnabled) done = true;
                        if (generatorConfig.yieldFinalResponse) yield finalResponse;
                    }
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            if (finalResponse?.type !== (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse) {
                // The stream ended without a valid FINAL_RESPONSE. This is not a
                // parse failure - it usually means an upstream error (e.g. Stargate
                // returning a non-2xx such as 404 FAILURE_CLIENT_TCS) short-circuited
                // the stream so the backend never emitted a final response body.
                const captureNoFinalResponseDetails = (0, $iDrrr.fg)('kd_sain_capture_backend_error_details');
                return {
                    state: 'failed',
                    reason: 'no_final_response',
                    error: 'Unexpected final response value',
                    details: captureNoFinalResponseDetails ? $90600a9a675bda6c$var$getNoFinalResponseDetails(finalResponse) : undefined,
                    traceId: captureNoFinalResponseDetails ? traceId ?? undefined : undefined
                };
            }
            return {
                state: 'complete',
                value: finalResponse
            };
        } catch (parsingError) {
            return {
                state: 'failed',
                reason: 'parsing',
                error: parsingError
            };
        }
    } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return {
            state: 'failed',
            reason: 'aborted'
        };
        if (error instanceof DOMException && error.name === 'TimeoutError') return {
            state: 'failed',
            reason: 'timeout'
        };
        if (error instanceof Error) return {
            state: 'failed',
            reason: 'error',
            details: error.message,
            error: error
        };
        return {
            state: 'failed',
            reason: 'unknown'
        };
    }
}
module.exports["sainStreamFetchConvoAIService"] = $90600a9a675bda6c$export$3e1bd964ad0ba888;
module.exports["aiDefinitionsStreamFetchConvoAIService"] = $90600a9a675bda6c$export$824b789d24de77d3;

});

parcelRegister("7zn5c", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $2wiZs = parcelRequire("2wiZs");

const $bd707cc6f6ee43a7$export$a68238496eb1c8ce = ({ abTestId: abTestId, onError: onError })=>{
    try {
        const cohort = (0, $cXtTj.default).getExperiment(abTestId).get('cohort', (0, $2wiZs.Cohort).Default);
        const serveExperiment = cohort === (0, $2wiZs.Cohort).Test;
        return {
            serveExperiment: serveExperiment,
            abTestId: abTestId,
            cohort: cohort
        };
    } catch (error) {
        onError?.(error);
    }
    return {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: (0, $2wiZs.Cohort).Default
    };
};
const $bd707cc6f6ee43a7$export$8774a01dc80b4a26 = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    if (!overrides) return $bd707cc6f6ee43a7$var$defaultCheckGate;
    try {
        const gates = overrides.filter((overrides)=>overrides.type === 'gate');
        const getFeatureGate = (name)=>{
            const overrideFeatureGate = gates.find((override)=>'name' in override && override.name === name);
            if (!overrideFeatureGate) return $bd707cc6f6ee43a7$var$defaultCheckGate(name);
            // Overrides always resolve to true as using an override is equivelant to turning FF on.
            return true;
        };
        return getFeatureGate;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$var$defaultCheckGate;
    }
};
const $bd707cc6f6ee43a7$export$841981a8a1feee8d = (overrides)=>{
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    if ((0, $cXtTj.default).checkGate('search-experiment-overrides-killswitch')) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    if (!overrides) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    try {
        const experiments = overrides.filter((overrides)=>overrides.type === 'experiment');
        const customGetFrontendExperiment = ({ abTestId: abTestId, onError: onError })=>{
            const overrideFrontendExperiment = experiments.find((override)=>'name' in override && override.name === abTestId);
            if (!overrideFrontendExperiment) return $bd707cc6f6ee43a7$export$a68238496eb1c8ce({
                abTestId: abTestId,
                onError: onError
            });
            return {
                abTestId: abTestId,
                serveExperiment: true,
                cohort: 'cohort' in overrideFrontendExperiment ? overrideFrontendExperiment.cohort : (0, $2wiZs.Cohort).Test
            };
        };
        return customGetFrontendExperiment;
    } catch (e) {
        console.error(e);
        return $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
    }
};
// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
const $bd707cc6f6ee43a7$var$defaultCheckGate = (name)=>(0, $cXtTj.default).checkGate(name);
const $bd707cc6f6ee43a7$export$b8cc3cdd046fba93 = (uiExperimentName, layerName, options = {
    fireLayerExposure: true
})=>{
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const frontendExperimentName = layer.get('frontendExperimentName', '');
    if (frontendExperimentName === uiExperimentName) return (0, $cXtTj.default).getLayer(layerName, options);
    return undefined;
};
module.exports["getFrontendExperiment"] = $bd707cc6f6ee43a7$export$a68238496eb1c8ce;
module.exports["createFeatureGateHandler"] = $bd707cc6f6ee43a7$export$8774a01dc80b4a26;
module.exports["createFrontendExperimentHandler"] = $bd707cc6f6ee43a7$export$841981a8a1feee8d;
module.exports["getMutuallyExclusiveUIExperiment"] = $bd707cc6f6ee43a7$export$b8cc3cdd046fba93;

});

parcelRegister("2wiZs", function(module, exports) {
var $695dfb69bc28d28c$export$b76685d1b5a37732 = /*#__PURE__*/ function(Cohort) {
    Cohort["Default"] = "not-enrolled";
    Cohort["Control"] = "control";
    Cohort["Test"] = "test";
    return Cohort;
}({});
module.exports["Cohort"] = $695dfb69bc28d28c$export$b76685d1b5a37732;

});

parcelRegister("7s8U5", function(module, exports) {
var $39c6704e11fb0392$export$130eddddf4243f3f = /*#__PURE__*/ function(AIAnswerQueryStreamType) {
    AIAnswerQueryStreamType["AnswerType"] = "ANSWER_TYPE";
    AIAnswerQueryStreamType["GenerationType"] = "ANSWER_GENERATION_TYPE";
    AIAnswerQueryStreamType["AnswerPart"] = "ANSWER_PART";
    AIAnswerQueryStreamType["FinalResponse"] = "FINAL_RESPONSE";
    AIAnswerQueryStreamType["Trace"] = "TRACE";
    AIAnswerQueryStreamType["ErrorStateQuerySuggestions"] = "ERROR_STATE_QUERY_SUGGESTIONS";
    AIAnswerQueryStreamType["DynamicLayoutSubAgentMessage"] = "DL_SUB_AGENT";
    AIAnswerQueryStreamType["EarlyStop"] = "EARLY_STOP";
    return AIAnswerQueryStreamType;
}({});
module.exports["AIAnswerQueryStreamType"] = $39c6704e11fb0392$export$130eddddf4243f3f;

});

parcelRegister("kqQyU", function(module, exports) {
var $75d15123b426d0da$export$6b1112c70cca65d3 = /*#__PURE__*/ function(NLPSearchErrorCodes) {
    NLPSearchErrorCodes["HIPAA_ENABLED_ERROR"] = "convoai.rest.browsing.product.has.hipaa.enabled";
    return NLPSearchErrorCodes;
}({});
module.exports["NLPSearchErrorCodes"] = $75d15123b426d0da$export$6b1112c70cca65d3;

});

parcelRegister("htnqN", function(module, exports) {
var $23c5d95fd834a4b7$export$9405d23bea8d0d8b = /*#__PURE__*/ function(NLPSearchErrorState) {
    NLPSearchErrorState["NoAnswer"] = "NO_ANSWER";
    NLPSearchErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NLPSearchErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NLPSearchErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NLPSearchErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NLPSearchErrorState["NoAnswerOpenAIResponseError"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NLPSearchErrorState["NoAnswerOpenAIRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NLPSearchErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NLPSearchErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    NLPSearchErrorState["AcceptableUseViolation"] = "ACCEPTABLE_USE_VIOLATIONS";
    NLPSearchErrorState["AIDisabled"] = "AI_DISABLED";
    NLPSearchErrorState["EarlyStop"] = "EARLY_STOP";
    // These values are not returned from the BE and are only used by the FE
    NLPSearchErrorState["Default"] = "DEFAULT";
    NLPSearchErrorState["NetworkError"] = "NETWORK_ERROR";
    NLPSearchErrorState["TimeoutError"] = "TIMEOUT_ERROR";
    NLPSearchErrorState["HIPAAError"] = "HIPAA_ERROR";
    NLPSearchErrorState["RenderError"] = "RENDER_ERROR";
    return NLPSearchErrorState;
}({});
module.exports["NLPSearchErrorState"] = $23c5d95fd834a4b7$export$9405d23bea8d0d8b;

});

parcelRegister("cuvLu", function(module, exports) {

var $9kP1w = parcelRequire("9kP1w");

const $24c5d3b79a8553ed$var$error = async ({ error: error, functionName: functionName, traceId: traceId })=>{
    try {
        const SentryClient = await (0, $9kP1w.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            scope.setTag('packageName', '@atlassian/search-ai');
            scope.setFingerprint([
                `functionName: ${functionName}`
            ]);
            if (traceId) scope.setTag('traceId', traceId);
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
const $24c5d3b79a8553ed$export$af88d00dbe7f521 = {
    error: $24c5d3b79a8553ed$var$error
};
module.exports["logger"] = $24c5d3b79a8553ed$export$af88d00dbe7f521;

});

parcelRegister("9kP1w", function(module, exports) {

var $4Z7Gy = parcelRequire("4Z7Gy");


var $1XLxS = parcelRequire("1XLxS");


var $21lBS = parcelRequire("21lBS");

let $31b5892e00f59305$var$Sentry;
const $31b5892e00f59305$var$beforeSend = (event)=>{
    // Delete the query string as it contains UGC
    if (event.request?.url) event.request.url = event.request.url.split('?')[0];
    if (event.request?.headers?.Referer) event.request.headers.Referer = event.request.headers.Referer.split('?')[0];
    if (event.environment === 'development') return null;
    return event;
};

const $31b5892e00f59305$export$f553e8b08ef59d31 = async ()=>{
    if (!$31b5892e00f59305$var$Sentry) $31b5892e00f59305$var$Sentry = (parcelRequire("eb0AO")).then((SentryModule)=>{
        SentryModule.init({
            dsn: (0, $21lBS.SENTRY_DSN),
            attachStacktrace: true,
            release: (0, $4Z7Gy.PRODUCT_BUILD) || (0, $21lBS.UNKNOWN_TAG),
            environment: (0, $1XLxS.getEnvironment)(),
            beforeSend: $31b5892e00f59305$var$beforeSend
        });
        return SentryModule;
    }).catch(()=>{
    // TODO: Retry mechanism for chunk loading failures?
    });
    return $31b5892e00f59305$var$Sentry;
};
module.exports["getSentryClient"] = $31b5892e00f59305$export$f553e8b08ef59d31;

});

parcelRegister("4Z7Gy", function(module, exports) {
// @ts-nocheck - extra properties on window are not known
/**
 * Constants for the build version of the product. Each product specifies
 * build version in a different way.
 *  - Jira: window.BUILD_KEY
 *  - Confluence: window.__buildInfo.FRONTEND_VERSION
 *  - For the service workers where window is not available, we return 'unknown'.
 */ const $9e905647717b836a$export$668f31ea3127f48f = (typeof window !== 'undefined' && (window.BUILD_KEY || window.__buildInfo?.FRONTEND_VERSION)) ?? 'unknown';
module.exports["PRODUCT_BUILD"] = $9e905647717b836a$export$668f31ea3127f48f;

});

parcelRegister("1XLxS", function(module, exports) {
const $95ec216372a1151c$export$57570b1603cf6adb = ()=>{
    if (window.location.hostname.includes('localhost')) return 'development';
    else if (window.location.hostname.includes('jira-dev.com') || window.location.hostname.includes('stg.atlassian.com')) return 'staging';
    else return 'production';
};
module.exports["getEnvironment"] = $95ec216372a1151c$export$57570b1603cf6adb;

});

parcelRegister("21lBS", function(module, exports) {
// https://atlassian-2y.sentry.io/projects/afm-search-ai/getting-started/
const $da80adf2194c7fdc$export$6faa4a850bc4d0ce = 'https://467ed23c400f1de490da05364bed5930@o55978.ingest.us.sentry.io/4507432686125056';
const $da80adf2194c7fdc$export$ea77880e3935182d = 'unknown';
module.exports["SENTRY_DSN"] = $da80adf2194c7fdc$export$6faa4a850bc4d0ce;
module.exports["UNKNOWN_TAG"] = $da80adf2194c7fdc$export$ea77880e3935182d;

});

parcelRegister("eb0AO", function(module, exports) {

let $a5228d740657b8b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5228d740657b8b1$var$load("aAWLw").then(()=>parcelRequire('eieXD'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("7DMz5", function(module, exports) {
// eslint-disable-next-line no-restricted-imports

var $1UWNP = parcelRequire("1UWNP");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $1XsRq = parcelRequire("1XsRq");

const $52567597a0df92ee$var$canRenderLuminaUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_dynamic_layout_in_sain')) return true;
    return false;
};
const $52567597a0df92ee$var$isSAINUXUpliftEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_team_26_sain_borderless_update')) return true;
    const helloLayer = (0, $cXtTj.default).getLayer((0, $1XsRq.SAIN_HELLO_LAYER_NAME));
    const helloCustomersEnabled = helloLayer.get('SAINUXUpliftEnabled', false);
    const customerLayer = (0, $cXtTj.default).getLayer((0, $1XsRq.SAIN_LAYER_NAME));
    const customersEnabled = customerLayer.get('SAINUXUpliftEnabled', false);
    if (helloCustomersEnabled || customersEnabled) return true;
    return false;
};
const $52567597a0df92ee$var$isSourcesInShortSAINAnswersEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_sain_show_sources_in_short_answers')) return true;
    return (0, $1XsRq.hasSAINLayerParamValue)('sourcesInShortSAINAnswers', 'test');
};
const $52567597a0df92ee$var$isZeroQuerySuggestionsV1EnabledUnmemoized = (primaryProduct)=>{
    if (primaryProduct === 'jira') return (0, $iDrrr.fg)('kd_jira_prequery_suggestions_v1');
    if (primaryProduct === 'confluence') return (0, $iDrrr.fg)('kd_confluence_prequery_suggestions_v1');
    return false;
};
const $52567597a0df92ee$var$isFullHeightLuminaEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_enable_full_height_lumina')) return true;
    return false;
};
const $52567597a0df92ee$var$isNonPrimaryClickTrackingEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_track_non_primary_clicks_gate')) return true;
    if ((0, $cXtTj.default).getExperimentValue('kd_track_non_primary_clicks', 'shouldTrackNonPrimaryClicks', 'control', {
        fireExperimentExposure: false
    }) === 'test') return true;
    return false;
};
const $52567597a0df92ee$var$triggerNonPrimaryClickTrackingExposure = ()=>{
    try {
        if (!(0, $iDrrr.fg)('kd_track_non_primary_clicks_gate')) (0, $cXtTj.default).manuallyLogExperimentExposure('kd_track_non_primary_clicks');
    } catch  {
    // Silently fail if FeatureGates is not available (e.g., in test environments)
    }
};
const $52567597a0df92ee$var$isNavigationalIntentEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_sain_enable_navigational_intent_gate')) return true;
    return false;
};
const $52567597a0df92ee$var$isInlineCitationsUpdateEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_team_26_sain_inline_citations_update')) return true;
    if ((0, $1XsRq.hasSAINHelloLayerParamValue)('InlineCitationUpdate', 'test')) return true;
    if ((0, $1XsRq.hasSAINLayerParamValue)('InlineCitationUpdate', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isLinkListSourcesEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_sain_link_list_sources')) return true;
    if ((0, $1XsRq.hasSAINUXLayerParamValue)('SAINRecentLinksListEnabled', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isImprovedChatOptionsEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_sain_improved_chat_options')) return true;
    if ((0, $1XsRq.hasSAINUXLayerParamValue)('SAINImprovedChatOptions', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isSAINUpdatedFlowEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_sain_user_flow_updates_enabled')) return true;
    if ((0, $1XsRq.hasSAINUXHelloLayerParamValue)('sainFlowUpdates', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isPeopleConnectorUXEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_sain_pt_person_team_26')) return true;
    if ((0, $1XsRq.hasSAINHelloLayerParamValue)('PeopleConnectorUXEnabled', 'treatment')) return true;
    if ((0, $1XsRq.hasSAINLayerParamValue)('PeopleConnectorUXEnabled', 'treatment')) return true;
    return false;
};
const $52567597a0df92ee$var$isSAINSourceProductUpdateEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_enable_lumina_list_3p_sources_attributes')) return true;
    if ((0, $1XsRq.hasSAINLayerParamValue)('SAINSourceProductUpdate', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isSAINLoadingStateTracesUpdateEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_enable_sain_loading_state_traces')) return true;
    if ((0, $1XsRq.hasSAINUXHelloLayerParamValue)('SAINLoadingStateTraces', 'test')) return true;
    if ((0, $1XsRq.hasSAINUXLayerParamValue)('SAINLoadingStateTraces', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isSAINScrollUpEnabledUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('kd_enable_sain_scroll_up')) return true;
    if ((0, $1XsRq.hasSAINUXHelloLayerParamValue)('SAINScrollUp', 'test')) return true;
    if ((0, $1XsRq.hasSAINUXLayerParamValue)('SAINScrollUp', 'test')) return true;
    return false;
};
const $52567597a0df92ee$var$isJiraSAINCardSmartLinkEnabledUnmemoized = ({ sourceProduct: sourceProduct })=>{
    const { serveExperiment: serveJiraFPSNLQNavigationExperiment } = (0, $1XsRq.getJiraUIExperienceLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_exp'
    });
    const { serveExperiment: serveJiraFPSNLQNavigationTenantsExperiment } = (0, $1XsRq.getJiraUIExperienceTenantsLayerFrontendExperiment)({
        abTestId: 'rovo_jira_nin_fps_nlq_navigation_tenants_exp'
    });
    return sourceProduct === 'jira' && ((0, $iDrrr.fg)('kd_jira_sain_card_smartlink_fg') || serveJiraFPSNLQNavigationExperiment || serveJiraFPSNLQNavigationTenantsExperiment);
};
const $52567597a0df92ee$var$DEFAULT_COLLAB_GRAPH_MODEL = 'cg_user_user_v4_';
const $52567597a0df92ee$var$getCollabGraphExperimentModelUnmemoized = ()=>{
    if ((0, $iDrrr.fg)('cg_sain_user_user_v5')) return 'cg_user_user_v5_regression';
    // Despite the experiment setup not returning an empty string,
    // `get` method can still return an empty string.
    const featureServiceModel = (0, $cXtTj.default).getExperiment('people-card-collaboration-graph-v5').get('featureServiceModel', $52567597a0df92ee$var$DEFAULT_COLLAB_GRAPH_MODEL);
    return featureServiceModel === '' ? $52567597a0df92ee$var$DEFAULT_COLLAB_GRAPH_MODEL : featureServiceModel;
};
const $52567597a0df92ee$export$1f65635c37e1bde3 = {
    canRenderLumina: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$canRenderLuminaUnmemoized),
    isSAINUXUpliftEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSAINUXUpliftEnabledUnmemoized),
    isFullHeightLuminaEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isFullHeightLuminaEnabledUnmemoized),
    isSourcesInShortSAINAnswersEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSourcesInShortSAINAnswersEnabledUnmemoized),
    isZeroQuerySuggestionsV1Enabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isZeroQuerySuggestionsV1EnabledUnmemoized),
    isNonPrimaryClickTrackingEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isNonPrimaryClickTrackingEnabledUnmemoized),
    triggerNonPrimaryClickTrackingExposure: $52567597a0df92ee$var$triggerNonPrimaryClickTrackingExposure,
    isJiraSAINCardSmartLinkEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isJiraSAINCardSmartLinkEnabledUnmemoized),
    isNavigationalIntentEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isNavigationalIntentEnabledUnmemoized),
    isInlineCitationsUpdateEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isInlineCitationsUpdateEnabledUnmemoized),
    isLinkListSourcesEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isLinkListSourcesEnabledUnmemoized),
    isPeopleConnectorUXEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isPeopleConnectorUXEnabledUnmemoized),
    isSAINUpdatedFlowEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSAINUpdatedFlowEnabledUnmemoized),
    isImprovedChatOptionsEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isImprovedChatOptionsEnabledUnmemoized),
    isSAINSourceProductUpdateEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSAINSourceProductUpdateEnabledUnmemoized),
    getCollabGraphExperimentModel: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$getCollabGraphExperimentModelUnmemoized),
    isSAINLoadingStateTracesUpdateEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSAINLoadingStateTracesUpdateEnabledUnmemoized),
    isSAINScrollUpEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))($52567597a0df92ee$var$isSAINScrollUpEnabledUnmemoized)
};
module.exports["SAINFeatureControl"] = $52567597a0df92ee$export$1f65635c37e1bde3;

});

parcelRegister("1XsRq", function(module, exports) {

var $1UWNP = parcelRequire("1UWNP");


var $cXtTj = parcelRequire("cXtTj");


var $7zn5c = parcelRequire("7zn5c");


var $fUTzE = parcelRequire("fUTzE");


var $cuvLu = parcelRequire("cuvLu");

const $1c4c47b3b90137c3$export$5091efb9b1abe9af = 'kd_sain_layer';
const $1c4c47b3b90137c3$export$61cd502eadfc7f4a = 'kd_sain_hello_layer';
const $1c4c47b3b90137c3$export$424fa15ff0b7ba = 'kd_sain_ux_layer';
const $1c4c47b3b90137c3$export$7ddc02143e0dc525 = 'kd_sain_ux_hello_layer';
const $1c4c47b3b90137c3$export$fb4dba971e54444f = 'rovo_jira_ui_experience_layer';
const $1c4c47b3b90137c3$export$50eae6f311ab1b36 = 'rovo_jira_ui_tenants_experience_layer';
function $1c4c47b3b90137c3$var$doesLayerFrontendExperimentExist(layerName, abTestId) {
    const layer = (0, $cXtTj.default).getLayer(layerName, {
        fireLayerExposure: false
    });
    const layerFrontendExperimentName = layer.get('frontendExperimentName', null);
    return layerFrontendExperimentName !== null && layerFrontendExperimentName === abTestId;
}
function $1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const falseEvaluationResult = {
        serveExperiment: false,
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
    const handleError = (error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if ((0, $fUTzE.isPartofSainHoldbackExperiment)()) return falseEvaluationResult;
        if ($1c4c47b3b90137c3$var$doesLayerFrontendExperimentExist(layerName, abTestId)) return (0, $7zn5c.getFrontendExperiment)({
            abTestId: abTestId,
            onError: handleError
        });
    } catch (error) {
        handleError(error);
    }
    return falseEvaluationResult;
}
const $1c4c47b3b90137c3$export$3de2a2aa2c11f251 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$5c2fc79d2a515e54 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$eff5ae0107dfb424 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$424fa15ff0b7ba
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$6a289441cb90b0e0 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$7ddc02143e0dc525
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$2ae87375886cb5b0 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$fb4dba971e54444f
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$399aed7d323465a6 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$50eae6f311ab1b36
    }), ({ abTestId: abTestId })=>abTestId);
function $1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({ layerName: layerName, abTestId: abTestId, onError: onError }) {
    const handleError = (error)=>{
        (0, $cuvLu.logger).error({
            error: error,
            functionName: `getLayerFrontendExperimentUnmemoized(${layerName})`
        });
        onError?.(error);
    };
    try {
        // we skip experiment evaluation if the user is part of the SAIN holdback experiment test cohort,
        // because SAIN is disabled in this case
        if (!(0, $fUTzE.isPartofSainHoldbackExperiment)() && $1c4c47b3b90137c3$var$doesLayerFrontendExperimentExist(layerName, abTestId)) {
            const experiment = (0, $cXtTj.default).getExperiment(abTestId);
            const cohort = experiment.get('cohort', 'not-enrolled');
            return {
                abTestId: abTestId,
                cohort: cohort
            };
        }
    } catch (error) {
        handleError(error);
    }
    return {
        abTestId: abTestId,
        cohort: 'not-enrolled'
    };
}
const $1c4c47b3b90137c3$export$3e4672526d3420fc = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$5091efb9b1abe9af
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$7ea065ff36b2919b = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$61cd502eadfc7f4a
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$86b1582e6f2170b8 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$424fa15ff0b7ba
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$51994ae426522802 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((params)=>$1c4c47b3b90137c3$var$getLayerFrontendMultiArmExperimentUnmemoized({
        ...params,
        layerName: $1c4c47b3b90137c3$export$7ddc02143e0dc525
    }), ({ abTestId: abTestId })=>abTestId);
const $1c4c47b3b90137c3$export$ef7d89c571d837a1 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$5091efb9b1abe9af);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$98e9af5151f46651 = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$ef7d89c571d837a1(paramName) === paramValue;
};
const $1c4c47b3b90137c3$export$2a3e1ea63f6e0a96 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$61cd502eadfc7f4a);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$acf5b4af6876c34 = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$2a3e1ea63f6e0a96(paramName) === paramValue;
};
const $1c4c47b3b90137c3$export$1cb8634000255dfc = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$424fa15ff0b7ba);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$73e8f0ae9f40c076 = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$1cb8634000255dfc(paramName) === paramValue;
};
const $1c4c47b3b90137c3$export$bc756838254fcee0 = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((paramName)=>{
    const layer = (0, $cXtTj.default).getLayer($1c4c47b3b90137c3$export$7ddc02143e0dc525);
    return layer.get(paramName, null);
}, (paramName)=>paramName);
const $1c4c47b3b90137c3$export$18e8e8d49cd8924f = (paramName, paramValue)=>{
    return $1c4c47b3b90137c3$export$bc756838254fcee0(paramName) === paramValue;
};
module.exports["SAIN_LAYER_NAME"] = $1c4c47b3b90137c3$export$5091efb9b1abe9af;
module.exports["SAIN_HELLO_LAYER_NAME"] = $1c4c47b3b90137c3$export$61cd502eadfc7f4a;
module.exports["getSAINLayerFrontendExperiment"] = $1c4c47b3b90137c3$export$3de2a2aa2c11f251;
module.exports["getJiraUIExperienceLayerFrontendExperiment"] = $1c4c47b3b90137c3$export$2ae87375886cb5b0;
module.exports["getJiraUIExperienceTenantsLayerFrontendExperiment"] = $1c4c47b3b90137c3$export$399aed7d323465a6;
module.exports["hasSAINLayerParamValue"] = $1c4c47b3b90137c3$export$98e9af5151f46651;
module.exports["hasSAINHelloLayerParamValue"] = $1c4c47b3b90137c3$export$acf5b4af6876c34;
module.exports["hasSAINUXLayerParamValue"] = $1c4c47b3b90137c3$export$73e8f0ae9f40c076;
module.exports["hasSAINUXHelloLayerParamValue"] = $1c4c47b3b90137c3$export$18e8e8d49cd8924f;

});

parcelRegister("fUTzE", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $3XLuW = parcelRequire("3XLuW");

function $5ecef285828a8671$export$c5e2c0a7fe245f7d() {
    const layer = (0, $cXtTj.default).getLayer((0, $3XLuW.STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN), {
        fireLayerExposure: false
    });
    const abTestId = layer.get('abTestId', 'no_ab_test_id');
    if (abTestId === 'kd_disable_sain_experiment') {
        const backendExperimentData = layer.get('backendChanges', {
            sain: true
        });
        if (!backendExperimentData?.sain) return true;
    }
    return false;
}
module.exports["isPartofSainHoldbackExperiment"] = $5ecef285828a8671$export$c5e2c0a7fe245f7d;

});

parcelRegister("3XLuW", function(module, exports) {
const $2bb5e141f8b5ba9a$export$71a8b319599e57dc = 'l1_premium_vs_standard';
const $2bb5e141f8b5ba9a$export$c076c4dd9e9d1e6e = 'search_platform_layer_l1_standard';
const $2bb5e141f8b5ba9a$export$23877616cb34cf0c = 'search_platform_layer_l1_premium';
const $2bb5e141f8b5ba9a$export$68be56e20dba0ed5 = 'l2_premium_vs_standard';
const $2bb5e141f8b5ba9a$export$f39fa5cd744578ae = 'search_platform_layer_l2_standard';
const $2bb5e141f8b5ba9a$export$a36d8c2d9981ec2b = 'search_platform_layer_l2_premium';
const $2bb5e141f8b5ba9a$export$fe025e19388affcf = 'search_platform_layer_l2_blending';
const $2bb5e141f8b5ba9a$export$11e2cd4e8edc5e82 = 'search_platform_layer_l3';
const $2bb5e141f8b5ba9a$export$9b30fb0a29b39382 = 'search_platform_layer_query_expansion';
const $2bb5e141f8b5ba9a$export$a62089c95934ccf8 = 'enable_l3';
const $2bb5e141f8b5ba9a$export$4e36729d15b3db9e = 'enable_query_rewrite';
const $2bb5e141f8b5ba9a$export$87f92c12fc8bb620 = 'search_platform_non_overlapping_domain';
const $2bb5e141f8b5ba9a$export$86bb6d2503529310 = 'search_platform_layer_l1';
const $2bb5e141f8b5ba9a$export$722a4624bef605fa = 'search_platform_layer_l2';
const $2bb5e141f8b5ba9a$export$1963cf4be1b2cd5e = 'search_platform_layer_l3';
const $2bb5e141f8b5ba9a$export$a18b3b3caa760214 = 'search_platform_layer_query_expansion';
const $2bb5e141f8b5ba9a$export$39bbb550e0341d58 = 'full_page_search_layer';
const $2bb5e141f8b5ba9a$export$b669e8e4ed2b4c67 = 'quick_find_layer';
const $2bb5e141f8b5ba9a$export$dd8503a49fbff14d = 'rovo_search_qf_experience_layer';
const $2bb5e141f8b5ba9a$export$afc3cbf9db978004 = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    controlId: 'default',
    abTestId: 'default'
};
const $2bb5e141f8b5ba9a$export$fca208e1e43c6fac = {
    experimentId: 'default',
    shadowExperimentId: 'default',
    experimentLayers: []
};
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L1_STANDARD_VS_PREMIUM"] = $2bb5e141f8b5ba9a$export$71a8b319599e57dc;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_STANDARD"] = $2bb5e141f8b5ba9a$export$c076c4dd9e9d1e6e;
module.exports["STATSIG_SEARCH_BACKEND_L1_LAYER_PREMIUM"] = $2bb5e141f8b5ba9a$export$23877616cb34cf0c;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L2_STANDARD_VS_PREMIUM"] = $2bb5e141f8b5ba9a$export$68be56e20dba0ed5;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_STANDARD"] = $2bb5e141f8b5ba9a$export$f39fa5cd744578ae;
module.exports["STATSIG_SEARCH_BACKEND_L2_LAYER_PREMIUM"] = $2bb5e141f8b5ba9a$export$a36d8c2d9981ec2b;
module.exports["STATSIG_SEARCH_BACKEND_L2_BLENDING_LAYER"] = $2bb5e141f8b5ba9a$export$fe025e19388affcf;
module.exports["STATSIG_SEARCH_BACKEND_L3_LAYER"] = $2bb5e141f8b5ba9a$export$11e2cd4e8edc5e82;
module.exports["STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER"] = $2bb5e141f8b5ba9a$export$9b30fb0a29b39382;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_L3_ENABLED"] = $2bb5e141f8b5ba9a$export$a62089c95934ccf8;
module.exports["STATSIG_SEARCH_BACKEND_FEATURE_GATE_QUERY_EXPANSION_ENABLED"] = $2bb5e141f8b5ba9a$export$4e36729d15b3db9e;
module.exports["STATSIG_SEARCH_BACKEND_NON_OVERLAPPING_DOMAIN"] = $2bb5e141f8b5ba9a$export$87f92c12fc8bb620;
module.exports["STATSIG_FULL_PAGE_SEARCH_LAYER"] = $2bb5e141f8b5ba9a$export$39bbb550e0341d58;
module.exports["STATSIG_QUICK_FIND_LAYER"] = $2bb5e141f8b5ba9a$export$b669e8e4ed2b4c67;
module.exports["DEFAULT_STATSIG_EXPERIMENT_CONFIG"] = $2bb5e141f8b5ba9a$export$afc3cbf9db978004;
module.exports["DEFAULT_STATSIG_PARALLEL_EXPERIMENTS_CONFIG"] = $2bb5e141f8b5ba9a$export$fca208e1e43c6fac;

});

parcelRegister("fn7C0", function(module, exports) {
// Cap the length of any single allow-listed field we record, as a defensive
// guard against unexpectedly large values.
const $bd76eade7433beb0$var$MAX_ERROR_FIELD_LENGTH = 200;
function $bd76eade7433beb0$export$1edcddfe6833792(rawBody) {
    if (!rawBody) return undefined;
    try {
        const parsed = JSON.parse(rawBody);
        const errorObj = parsed?.error ?? parsed;
        if (!errorObj || typeof errorObj !== 'object') return undefined;
        const clip = (value)=>typeof value === 'string' && value.length > 0 ? value.slice(0, $bd76eade7433beb0$var$MAX_ERROR_FIELD_LENGTH) : typeof value === 'number' ? String(value) : undefined;
        // Allow-list of non-UGC identifiers only. Deliberately excludes free-form
        // message text, which may contain user-generated content.
        const key = clip(errorObj.key ?? errorObj.type ?? errorObj.code);
        const statusCode = clip(errorObj.statusCode ?? errorObj.status);
        const safe = {};
        if (key) safe.key = key;
        if (statusCode) safe.statusCode = statusCode;
        return Object.keys(safe).length > 0 ? JSON.stringify(safe) : undefined;
    } catch  {
        // Non-JSON body (e.g. HTML error page) - do not record it, to avoid UGC.
        return undefined;
    }
}
module.exports["extractStructuredErrorDetails"] = $bd76eade7433beb0$export$1edcddfe6833792;

});

parcelRegister("EZPsO", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7s8U5 = parcelRequire("7s8U5");


var $htnqN = parcelRequire("htnqN");


var $hpFQM = parcelRequire("hpFQM");


var $cuvLu = parcelRequire("cuvLu");


var $7DMz5 = parcelRequire("7DMz5");


var $g7itP = parcelRequire("g7itP");


var $3v6Cp = parcelRequire("3v6Cp");


var $7s0JE = parcelRequire("7s0JE");


var $fhQSR = parcelRequire("fhQSR");

const $18420cdcd30a1600$var$mapMimeTypeToFormat = (mimeType)=>{
    switch(mimeType){
        case 'text/markdown':
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
        case 'text/adf':
            return (0, $hpFQM.NLPSearchResultFormat).ADF;
        case 'text/json':
            return (0, $hpFQM.NLPSearchResultFormat).JSON;
        default:
            return (0, $hpFQM.NLPSearchResultFormat).MARKDOWN;
    }
};
const $18420cdcd30a1600$var$mapErrorTo = (error, traceId)=>{
    const errorMessage = 'message_template' in error ? error.message_template : error.message.message_template;
    switch(errorMessage){
        case 'NO_ANSWER_LLM':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswer
            };
        case 'NO_ANSWER_PEOPLE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerWhoQuestion
            };
        case 'NO_ANSWER_KEYWORDS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerKeywords
            };
        case 'NO_ANSWER_SEARCH_QA_PLUGIN':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerSearchResults
            };
        case 'ACCEPTABLE_USE_VIOLATIONS':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AcceptableUseViolation
            };
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NoAnswerOpenAIRateLimitUserAbuse
            };
        case 'FEATURE_DISABLED_ON_SITE':
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).AIDisabled
            };
        default:
            (0, $cuvLu.logger).error({
                error: error,
                functionName: 'mapErrorToSain: NetworkError',
                traceId: traceId
            });
            return {
                errorState: (0, $htnqN.NLPSearchErrorState).NetworkError,
                networkErrorReason: 'unmapped_backend_error',
                networkErrorDetails: errorMessage,
                backendFailureType: 'unmapped_template'
            };
    }
};
const $18420cdcd30a1600$var$identityUserCloudARIPrefix = 'ari:cloud:identity::user/';
const $18420cdcd30a1600$export$b4465cb8e5734ca9 = (message, requestId)=>{
    // Handle cases where message is directly in root or nested under message.message
    const messageContent = message.message;
    // The CSM streaming endpoint puts sources inside SAINMessage (message.message.sources)
    // rather than at the SAINAgentResponse level (message.sources). Fall back to the
    // nested location so citations and the Sources section render correctly for both the APIs.
    const sources = message.sources ?? message.message?.sources;
    return {
        nlpResult: (0, $iDrrr.fg)('kd_sain_extract_footnote') ? (0, $g7itP.cleanSAINAnswerCitations)(messageContent.content) : messageContent.content,
        uniqueSources: sources ? sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null,
                ...source.connectorInfo && (0, $iDrrr.fg)('kd_sain_connector_info_analytics') && {
                    connectorInfo: source.connectorInfo
                }
            })) : [],
        disclaimer: messageContent.message_metadata?.disclaimer ?? null,
        errorState: null,
        format: $18420cdcd30a1600$var$mapMimeTypeToFormat(messageContent.content_mime_type),
        extraAPIAnalyticsAttributes: {
            message_id: messageContent.id,
            conversational_channel_id: messageContent.conversation_channel_id,
            experience_id: messageContent.experience_id,
            user_id: messageContent.user_ari?.replace($18420cdcd30a1600$var$identityUserCloudARIPrefix, '') ?? null,
            userQuery: message.human_message?.content ?? null,
            requestId: (0, $iDrrr.fg)('kd_fix_sain_mau_instrumentation') ? requestId ?? null : messageContent.message_metadata?.request_id ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $iDrrr.fg)('kd_consolidate_sources_analytics') && {
                sources: sources
            },
            cacheInfo: messageContent.message_metadata?.global_cache_info ?? null,
            pluginInvocations: messageContent.plugin_invocations,
            rawJson: message,
            ...(0, $iDrrr.fg)('kd_sain_online_debugger') && {
                minion_outputs: message.message?.minion_outputs,
                traceId: requestId ?? null
            },
            ...(0, $iDrrr.fg)('kd_add_plugins_invoked') && (()=>{
                const pluginNames = (messageContent.plugin_invocations ?? []).map((p)=>p.plugin_name).filter(Boolean);
                const minionOutputs = messageContent.minion_outputs ?? [];
                const minionIds = minionOutputs.flat().map((m)=>m.minion_id).filter(Boolean);
                const pluginsInvoked = [
                    ...pluginNames,
                    ...minionIds
                ];
                return pluginsInvoked.length > 0 ? {
                    pluginsInvoked: pluginsInvoked
                } : {};
            })()
        },
        authority_ui_metadata: messageContent.authority_ui_metadata ?? null
    };
};
const $18420cdcd30a1600$export$ed070f749797478 = (response, traceId)=>{
    if ((0, $fhQSR.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $18420cdcd30a1600$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $fhQSR.isStreamGenerationType)(response) && (0, $7DMz5.SAINFeatureControl).canRenderLumina()) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).GenerationType,
        message: {
            answer_generation_type: response.message.answer_generation_type
        }
    };
    if ((0, $fhQSR.isStreamTrace)(response)) {
        // When the new user-flow FG is on, also surface the rich research-step
        // fields if the BE included a `message_template` (RESEARCH_STEP_*, etc).
        // Legacy traces are unaffected — they just won't carry `traceData`.
        const includeTraceData = ((0, $7DMz5.SAINFeatureControl).isSAINUpdatedFlowEnabled() || (0, $7DMz5.SAINFeatureControl).isSAINLoadingStateTracesUpdateEnabled()) && !!response.message.message_template;
        return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).Trace,
            message: response.message.content,
            ...includeTraceData && {
                traceData: {
                    messageTemplate: response.message.message_template,
                    title: response.message.title,
                    stepId: response.message.stepId,
                    roundId: response.message.roundId,
                    content: response.message.content,
                    toolName: response.message.toolName,
                    toolIcon: response.message.toolIcon,
                    products: response.message.products,
                    sources: response.message.sources ?? undefined,
                    url: response.message.url,
                    product: response.message.product
                }
            }
        };
    }
    if ((0, $fhQSR.isStreamAnswerPart)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: (0, $iDrrr.fg)('kd_fix_streaming_hr_line') ? (0, $7s0JE.stripLeadingHorizontalRule)(response.message.content) : response.message.content
        }
    };
    if ((0, $fhQSR.isStreamSAINResponse)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
        message: $18420cdcd30a1600$export$b4465cb8e5734ca9(response.message, traceId)
    };
    if ((0, $fhQSR.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    if ((0, $fhQSR.isStreamErrorStateQuerySuggestions)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).ErrorStateQuerySuggestions,
        suggested_queries: response.message.suggested_queries ?? []
    };
    if ((0, $7DMz5.SAINFeatureControl).canRenderLumina()) {
        if ((0, $fhQSR.isStreamDynamicLayoutSubAgent)(response)) return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).DynamicLayoutSubAgentMessage,
            message: response.message
        };
    }
    if ((0, $iDrrr.fg)('kd_sain_early_stop_hello_exp_fg') || (0, $iDrrr.fg)('kd_sain_early_stop_customer_exp_fg')) {
        if ((0, $fhQSR.isStreamEarlyStop)(response)) {
            const earlyStopSearchResult = {
                nlpResult: response.message?.reason ?? '',
                format: null,
                uniqueSources: [],
                errorState: (0, $htnqN.NLPSearchErrorState).EarlyStop,
                disclaimer: null
            };
            return {
                type: (0, $7s8U5.AIAnswerQueryStreamType).EarlyStop,
                message: earlyStopSearchResult
            };
        }
    }
    if (response.type === 'PLUGIN_INVOCATION' && response.message?.plugin_name) return {
        type: 'plugin-invocation',
        pluginName: response.message.plugin_name
    };
    return {
        type: 'other'
    };
};
const $18420cdcd30a1600$export$fb9e9bea38ae660f = (response, traceId)=>{
    if ((0, $fhQSR.isStreamError)(response)) {
        const { errorState: errorState, networkErrorReason: networkErrorReason, networkErrorDetails: networkErrorDetails, backendFailureType: backendFailureType } = $18420cdcd30a1600$var$mapErrorTo(response, traceId);
        return {
            type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
            message: {
                errorState: errorState,
                errorCode: response.message.status_code,
                networkErrorReason: networkErrorReason,
                networkErrorDetails: networkErrorDetails,
                backendFailureType: backendFailureType,
                disclaimer: null,
                format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
                uniqueSources: []
            }
        };
    }
    if ((0, $fhQSR.isStreamTrace)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).Trace,
        message: response.message.content
    };
    if ((0, $fhQSR.isStreamAnswerPart)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).AnswerPart,
        message: {
            nlpResult: response.message.content
        }
    };
    if ((0, $fhQSR.isStreamDefinitionResponse)(response)) return {
        type: (0, $7s8U5.AIAnswerQueryStreamType).FinalResponse,
        message: (0, $3v6Cp.mapDefinitionMessageToNLPSearchType)(response.message, traceId)
    };
    if ((0, $fhQSR.isStreamFollowUp)(response)) return {
        type: 'follow-up',
        queries: response.message.follow_up_queries ?? []
    };
    return {
        // Don't currently handle other types, such as PLUGIN_INVOCATION
        type: 'other'
    };
};
module.exports["mapStreamSAINResponse"] = $18420cdcd30a1600$export$ed070f749797478;
module.exports["mapStreamDefinitionResponse"] = $18420cdcd30a1600$export$fb9e9bea38ae660f;

});

parcelRegister("g7itP", function(module, exports) {
const $c9bf059aebe9542e$export$231abbb3de9b00b5 = (result)=>{
    const removeFootnoteRegex = /\[\^(\d{1,2})\^\]:\s*https?:\/\/.*$/gm;
    const removeNonDigitCitationsRegex = /\[\^([a-zA-Z\-]+)\^\]/g;
    let cleanedAnswer = result.replace(removeFootnoteRegex, '').trim();
    cleanedAnswer = cleanedAnswer.replace(removeNonDigitCitationsRegex, '').trim();
    return cleanedAnswer;
};
module.exports["cleanSAINAnswerCitations"] = $c9bf059aebe9542e$export$231abbb3de9b00b5;

});

parcelRegister("3v6Cp", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hpFQM = parcelRequire("hpFQM");

const $3a550909e4e16fa5$export$b4d3daa122c7e257 = (message, traceId)=>{
    return {
        nlpResult: message.content,
        uniqueSources: message.sources ? message.sources.map((source)=>({
                ari: source.ari,
                id: source.id?.toString(),
                title: source.title,
                product: source.product,
                type: source.type,
                url: source.url,
                lastModified: source.lastModified,
                iconUrl: null,
                spaceName: null,
                spaceUrl: null,
                ...source.connectorInfo && (0, $iDrrr.fg)('kd_definitions_connector_info_analytics') && {
                    // Definitions provides the source product at the top level when connector metadata omits it.
                    connectorInfo: {
                        provider_id: source.connectorInfo.provider_id,
                        connector_type: source.connectorInfo.connector_type,
                        searchRetrievalType: source.connectorInfo.searchRetrievalType,
                        sourceProduct: source.connectorInfo.sourceProduct ?? source.product ?? undefined
                    }
                }
            })) : [],
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
        extraAPIAnalyticsAttributes: {
            requestId: traceId ?? null,
            userQuery: message.human_message?.content ?? null,
            answerGenerationModel: message.usage_data ?? null,
            ...!(0, $iDrrr.fg)('kd_consolidate_sources_analytics') && {
                sources: message.sources
            },
            rawJson: message
        }
    };
};
module.exports["mapDefinitionMessageToNLPSearchType"] = $3a550909e4e16fa5$export$b4d3daa122c7e257;

});

parcelRegister("7s0JE", function(module, exports) {
/**
 * Strips a leading markdown horizontal rule (`----` / `---`) that the backend
 * occasionally sends as the very first streamed chunk.  When rendered
 * incrementally by `use-buffered-content`, this produces a large grey `<hr>`
 * line that disappears once the full answer arrives, causing an unwanted flash.
 *
 * The pattern `\n\n---+\n\n` only matches when the rule appears at the very
 * start of the content so legitimate mid-answer dividers are preserved.
 */ const $eca07c9d38f17ebd$export$4cbb8bd973cd24f9 = (content)=>{
    return content.replace(/^\n*-{3,}\n*/, '');
};
module.exports["stripLeadingHorizontalRule"] = $eca07c9d38f17ebd$export$4cbb8bd973cd24f9;

});

parcelRegister("fhQSR", function(module, exports) {
const $77022310b2d5138b$export$b4631726cbc1440a = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $77022310b2d5138b$export$d422a2733a3b5def = (message)=>message instanceof Object && message.type === 'ERROR';
const $77022310b2d5138b$export$e45102edbc73b240 = (message)=>message instanceof Object && message.type === 'ANSWER_PART';
const $77022310b2d5138b$export$c563bc6129a38894 = (message)=>message instanceof Object && message.type === 'ANSWER_GENERATION_TYPE';
const $77022310b2d5138b$export$fd5a05be03f147a0 = (message)=>message instanceof Object && message.type === 'TRACE';
const $77022310b2d5138b$export$51a1b4e474708d74 = (message)=>message instanceof Object && message.type === 'PLUGIN_INVOCATION';
const $77022310b2d5138b$export$cfb6b6bb809f778e = (message)=>message instanceof Object && message.type === 'FOLLOW_UP_QUERIES';
const $77022310b2d5138b$export$de29cc71fd2aafc1 = (message)=>message instanceof Object && message.type === 'ERROR_STATE_QUERY_SUGGESTIONS';
const $77022310b2d5138b$export$5fa02529cd2ab34c = (message)=>message instanceof Object && message.type === 'DL_SUB_AGENT';
const $77022310b2d5138b$export$b6b59db8d0b45219 = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
const $77022310b2d5138b$export$1598409b78d1d369 = (message)=>message instanceof Object && message.type === 'EARLY_STOP';
const $77022310b2d5138b$export$53e95dec5f877b4e = (message)=>message instanceof Object && message.type === 'FINAL_RESPONSE';
module.exports["isStreamError"] = $77022310b2d5138b$export$d422a2733a3b5def;
module.exports["isStreamAnswerPart"] = $77022310b2d5138b$export$e45102edbc73b240;
module.exports["isStreamGenerationType"] = $77022310b2d5138b$export$c563bc6129a38894;
module.exports["isStreamTrace"] = $77022310b2d5138b$export$fd5a05be03f147a0;
module.exports["isStreamFollowUp"] = $77022310b2d5138b$export$cfb6b6bb809f778e;
module.exports["isStreamErrorStateQuerySuggestions"] = $77022310b2d5138b$export$de29cc71fd2aafc1;
module.exports["isStreamDynamicLayoutSubAgent"] = $77022310b2d5138b$export$5fa02529cd2ab34c;
module.exports["isStreamSAINResponse"] = $77022310b2d5138b$export$b6b59db8d0b45219;
module.exports["isStreamEarlyStop"] = $77022310b2d5138b$export$1598409b78d1d369;
module.exports["isStreamDefinitionResponse"] = $77022310b2d5138b$export$53e95dec5f877b4e;

});

parcelRegister("u7MPJ", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $a12cf3bdcfab939f$export$1b6ec2a437dbf65e = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiCuratedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchCuratedDefinitionErrorPayload"] = $a12cf3bdcfab939f$export$1b6ec2a437dbf65e;

});

parcelRegister("4Tg3t", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7DMz5 = parcelRequire("7DMz5");


var $9oghv = parcelRequire("9oghv");


var $fRZe0 = parcelRequire("fRZe0");


var $jxCYp = parcelRequire("jxCYp");


var $6r8zo = parcelRequire("6r8zo");


var $agG6W = parcelRequire("agG6W");

// list from https://atlassian.slack.com/archives/C08VA0N40A2/p1749172242825969?thread_ts=1749088363.059769&cid=C08VA0N40A2
const $25e050b8a4f8e071$var$products1PList = [
    'Assets',
    'Atlas',
    'Confluence',
    'Atlassian Analytics',
    'Atlassian Cloud',
    'Automation for Jira',
    'Bamboo',
    'Bitbucket',
    'Compass',
    'Jira',
    'Jira Product Discovery',
    'Jira Service Management',
    'Jira Software',
    'Jira Work Management',
    'Jira Align',
    'Migration',
    'Loom',
    'Opsgenie',
    'Platform Experiences',
    'Rovo',
    'Statuspage',
    'Trello',
    'webSearch',
    'web-page',
    'Fisheye and Crucible',
    'Crowd',
    'Sourcetree',
    'Unknown',
    'Focus',
    'file-upload',
    'Advanced Roadmaps For Jira',
    'Questions for Confluence',
    'csm',
    'Dewey Support',
    'Dewey JAC Support',
    'Help Aggregator'
];
const $25e050b8a4f8e071$var$noAnswerPhrases = [
    "i'm sorry",
    'i apologize',
    "couldn't find ",
    "couldn't generate",
    'provide more context',
    "don't have enough information"
];
const $25e050b8a4f8e071$export$e9cf531f9f13a177 = (text)=>{
    const lowerCaseText = text.toLowerCase();
    return $25e050b8a4f8e071$var$noAnswerPhrases.some((phrase)=>lowerCaseText.includes(phrase));
};
const $25e050b8a4f8e071$var$getSourceProducts = (sources, luminaUrls = [])=>{
    const products = {};
    sources.forEach((source)=>{
        const productName = source.product;
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    // `luminaUrls` are expected to already deduped
    luminaUrls.forEach((url)=>{
        try {
            const productName = (0, $agG6W.getProductKey)(url);
            if (productName) products[productName] = (products[productName] ?? 0) + 1;
        } catch  {
            return;
        }
    });
    return products;
};
const $25e050b8a4f8e071$var$getLuminaLinkProducts = (luminaLinkProducts = [])=>{
    const products = {};
    luminaLinkProducts.forEach((productName)=>{
        if (productName) products[productName] = (products[productName] ?? 0) + 1;
    });
    return products;
};
const $25e050b8a4f8e071$var$sanitizeSources = (sources)=>sources.map((source)=>({
            id: source.ari ?? source.id,
            type: source.type
        }));
const $25e050b8a4f8e071$export$48acf215f1610b8e = (sources, isReadingAids)=>{
    const isConnectorInfoAnalyticsEnabled = isReadingAids ? (0, $iDrrr.fg)('kd_definitions_connector_info_analytics') : (0, $iDrrr.fg)('kd_sain_connector_info_analytics');
    if (!isConnectorInfoAnalyticsEnabled) return undefined;
    const connectorInfo = sources.flatMap((source)=>{
        const { provider_id: provider_id, connector_type: connector_type, searchRetrievalType: searchRetrievalType, sourceProduct: sourceProduct } = source.connectorInfo ?? {};
        if (!provider_id && !connector_type && !searchRetrievalType && !sourceProduct) return [];
        return [
            {
                ...sourceProduct && {
                    source_product: sourceProduct
                },
                ...connector_type && {
                    connector_type: connector_type
                },
                ...provider_id && {
                    provider_id: provider_id
                },
                ...searchRetrievalType && {
                    search_retrieval_type: searchRetrievalType
                }
            }
        ];
    });
    return connectorInfo.length ? connectorInfo : undefined;
};
const $25e050b8a4f8e071$export$fae1292002da0b83 = (sources)=>sources.filter((source)=>source.product ? !$25e050b8a4f8e071$var$products1PList.includes(source.product) && !source.product.includes('Plugin') : false);
const $25e050b8a4f8e071$var$filterLumina3PUrls = (urls)=>urls.filter((url)=>{
        try {
            const product = (0, $agG6W.getProductKey)(url);
            return $25e050b8a4f8e071$export$c33e27f4ca8bdbe0(product);
        } catch  {
            return false;
        }
    });
const $25e050b8a4f8e071$export$c33e27f4ca8bdbe0 = (product)=>product ? !$25e050b8a4f8e071$var$products1PList.includes(product) && !product.includes('Plugin') : false;
const $25e050b8a4f8e071$export$988d4f126deef74 = (extraAttributes)=>{
    if (!(0, $iDrrr.fg)('kd_fe_sanitize_analytics')) return extraAttributes;
    const sanitizedAttributes = {};
    // Sanitize everything except COMMON_ALLOWED_KEYS
    for(const key in extraAttributes)if ((0, $fRZe0.ALLOWED_EXTRA_ATTRIBUTES_KEYS).has(key)) sanitizedAttributes[key] = extraAttributes[key];
    else // replacing with text because the value has type `any`
    sanitizedAttributes[key] = '[sanitized]';
    return sanitizedAttributes;
};
/**
 * Keys produced by `filterCommonAttributes` (including optional and feature-gated fields). Keep in
 * sync when adding new attributes there — `SEARCH_AI_ANALYTICS_CONTEXT_ATTRIBUTE_ALLOWLIST` is
 * derived from this list plus `ALLOWED_EXTRA_ATTRIBUTES_KEYS`, `location`, and `source`.
 */ const $25e050b8a4f8e071$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS = [
    'searchSessionId',
    'queryHash',
    'baseQueryHash',
    'wordCount',
    'queryLength',
    'answerHash',
    'appliedFilters',
    'answerFormat',
    'answerLength',
    'answerWordCount',
    'answerCardType',
    'followUpsCount',
    'followUpsLength',
    'has3PSources',
    'sources',
    'sourceProducts',
    'apiSource',
    'brand',
    'sessionId',
    'isHello',
    'sourceProduct',
    'isReadingAids',
    'queryIntent',
    'rovoJourneyId',
    'sourcesCount',
    'sources3P',
    'sources3PCount',
    'hasSources',
    'has1PSources',
    'containsNoAnswerPhrase',
    'containsLuminaContent',
    'luminaContentTypes',
    'jiraNlToJqlCardVariant',
    'connectorInfo',
    'luminaLinkProducts'
];
const $25e050b8a4f8e071$export$26c187b85342c353 = new Set([
    'location',
    'source',
    ...$25e050b8a4f8e071$var$FILTER_COMMON_ATTRIBUTES_OUTPUT_KEYS,
    ...(0, $fRZe0.ALLOWED_EXTRA_ATTRIBUTES_KEYS)
]);
const $25e050b8a4f8e071$export$5e5d3678c52c4007 = (data)=>{
    const location = data.location;
    const raw = {
        ...data.attributes
    };
    if (raw.location === undefined) raw.location = location;
    const attributes = {};
    for (const key of Object.keys(raw))if ($25e050b8a4f8e071$export$26c187b85342c353.has(key)) attributes[key] = raw[key];
    return {
        attributes: attributes,
        location: location
    };
};
const $25e050b8a4f8e071$export$14f72eaec5bfc1a8 = (props)=>{
    const { appliedFilters: appliedFilters, answerFormat: answerFormat, answerLength: answerLength, answerWordCount: answerWordCount, answerCardType: answerCardType, followUps: followUps, sources: sources, extraAttributes: extraAttributes, searchSessionId: searchSessionId, queryHash: queryHash, baseQueryHash: baseQueryHash, query: query, answerString: answerString, apiSource: apiSource, brand: brand, sourceProduct: sourceProduct, isReadingAids: isReadingAids, queryIntent: queryIntent, sessionId: sessionId, rovoJourneyId: rovoJourneyId, isHello: isHello, containsLuminaContent: containsLuminaContent, luminaContentTypes: luminaContentTypes, luminaContentMap: luminaContentMap } = props;
    const filtered3P = $25e050b8a4f8e071$export$fae1292002da0b83(sources);
    const luminaUrls = (0, $7DMz5.SAINFeatureControl).isSAINSourceProductUpdateEnabled() ? (0, $6r8zo.extractLuminaUrls)(luminaContentMap ?? {}) : [];
    // Dedupe lumina URLs against the existing sources so we don't double-count URLs
    // that are already represented in `sources` (which includes all 3P sources).
    const sourceUrls = new Set(sources.map((source)=>source.url));
    const dedupedLuminaUrls = luminaUrls.filter((url)=>!sourceUrls.has(url));
    const filteredLumina3P = $25e050b8a4f8e071$var$filterLumina3PUrls(dedupedLuminaUrls);
    return {
        searchSessionId: searchSessionId,
        queryHash: queryHash,
        baseQueryHash: baseQueryHash,
        wordCount: (query.match(/\w+/g) || []).length,
        queryLength: query.length,
        answerHash: (0, $9oghv.sha256Hash)(answerString),
        appliedFilters: appliedFilters,
        answerFormat: answerFormat,
        answerLength: answerLength,
        answerWordCount: answerWordCount,
        answerCardType: answerCardType,
        followUpsCount: followUps.length,
        followUpsLength: followUps.map((followUp)=>followUp.length),
        has3PSources: filtered3P.length > 0 || filteredLumina3P.length > 0,
        sources: $25e050b8a4f8e071$var$sanitizeSources(sources),
        sourceProducts: $25e050b8a4f8e071$var$getSourceProducts(sources, dedupedLuminaUrls),
        apiSource: apiSource,
        brand: brand,
        ...sourceProduct !== undefined && {
            sourceProduct: sourceProduct
        },
        ...isReadingAids !== undefined && {
            isReadingAids: isReadingAids
        },
        ...queryIntent !== undefined && {
            queryIntent: queryIntent
        },
        ...containsLuminaContent !== undefined && {
            containsLuminaContent: containsLuminaContent
        },
        ...luminaContentTypes !== undefined && {
            luminaContentTypes: luminaContentTypes
        },
        ...(0, $iDrrr.fg)('kd_consolidate_sources_analytics') && {
            sourcesCount: sources.length + dedupedLuminaUrls.length,
            sources3P: $25e050b8a4f8e071$var$sanitizeSources(filtered3P),
            sources3PCount: filtered3P.length + filteredLumina3P.length
        },
        ...(0, $iDrrr.fg)('kd_send_no_answer_attributes') && {
            hasSources: sources.length > 0,
            has1PSources: sources.length > filtered3P.length,
            containsNoAnswerPhrase: $25e050b8a4f8e071$export$e9cf531f9f13a177(answerString)
        },
        ...(()=>{
            const connectorInfo = $25e050b8a4f8e071$export$48acf215f1610b8e(sources, isReadingAids);
            return connectorInfo !== undefined && {
                connectorInfo: connectorInfo
            };
        })(),
        ...(0, $iDrrr.fg)('kd_sain_lumina_link_product_temp') && {
            luminaLinkProducts: $25e050b8a4f8e071$var$getLuminaLinkProducts((0, $jxCYp.extractLuminaLinkProducts)(luminaContentMap ?? {}))
        },
        sessionId: sessionId,
        ...rovoJourneyId !== undefined && (0, $iDrrr.fg)('rovo_search_chat_convergence') && {
            rovoJourneyId: rovoJourneyId
        },
        isHello: isHello,
        ...$25e050b8a4f8e071$export$988d4f126deef74(extraAttributes)
    };
};
module.exports["extractConnectorInfo"] = $25e050b8a4f8e071$export$48acf215f1610b8e;
module.exports["isSourceProduct3P"] = $25e050b8a4f8e071$export$c33e27f4ca8bdbe0;
module.exports["sanitizeExtraAttributes"] = $25e050b8a4f8e071$export$988d4f126deef74;
module.exports["sanitizeSearchAIAnalyticsContextData"] = $25e050b8a4f8e071$export$5e5d3678c52c4007;
module.exports["filterCommonAttributes"] = $25e050b8a4f8e071$export$14f72eaec5bfc1a8;

});

parcelRegister("9oghv", function(module, exports) {

var $eVK28 = parcelRequire("eVK28");

const $0afda9e797c2a356$export$e9131c78c1110376 = (str)=>(0, $eVK28.sha256)(str);
module.exports["sha256Hash"] = $0afda9e797c2a356$export$e9131c78c1110376;

});

parcelRegister("fRZe0", function(module, exports) {
/**
 * Any keys that exactly match an entry in this Set will _NOT_ be sanitized. So be sure that anything
 * you add here will not contain PII or UGC
 *
 * Exported for unit tests: `analytics-helpers-test` keeps a duplicate list that must match — so
 * extending the allowlist requires updating that test (and review).
 */ const $d4b17abe12e8a132$export$dff579a44dd3965d = new Set([
    'contentId',
    'readingAidsSessionId',
    'fieldType',
    'multipleUserResultsShown',
    'numAddtlWhoMatches',
    'isCuratedDefinition',
    'isPrecomputedDefinition',
    'editDistance',
    'bookmarkId',
    'bookmarkState',
    'dwellTime',
    'availableProducts',
    'isDescriptionEmpty',
    // from extraAPIAnalyticsAttributes
    'message_id',
    'conversational_channel_id',
    'experience_id',
    'user_id',
    // Deduplicated list of plugin names and minion IDs invoked during the AI answer generation
    'pluginsInvoked',
    // from extraAnalyticsAttributes
    'experiments',
    'featureGates',
    'isFullPageSearch',
    'has3pProducts',
    'is3pSearch',
    'mode',
    'triggeredBy',
    'referrer',
    'requestId'
]);
module.exports["ALLOWED_EXTRA_ATTRIBUTES_KEYS"] = $d4b17abe12e8a132$export$dff579a44dd3965d;

});

parcelRegister("jxCYp", function(module, exports) {
const $de6245fec67c724b$var$PRODUCT_REGEX = /product="([^"]+)"/g;
const $de6245fec67c724b$export$d1c50b95402c4704 = (luminaContentMap)=>{
    const products = [];
    for (const value of Object.values(luminaContentMap))for (const match of value.matchAll($de6245fec67c724b$var$PRODUCT_REGEX))products.push(match[1]);
    return products;
};
module.exports["extractLuminaLinkProducts"] = $de6245fec67c724b$export$d1c50b95402c4704;

});

parcelRegister("6r8zo", function(module, exports) {
const $f454e58bf727a41f$var$URL_REGEX = /url="([^"]+)"/g;
const $f454e58bf727a41f$export$b2d8940859284af3 = (luminaContentMap)=>{
    const urls = [];
    for (const value of Object.values(luminaContentMap))for (const match of value.matchAll($f454e58bf727a41f$var$URL_REGEX))urls.push(match[1]);
    return urls;
};
module.exports["extractLuminaUrls"] = $f454e58bf727a41f$export$b2d8940859284af3;

});

parcelRegister("agG6W", function(module, exports) {
// utility function copied from /rovo-extension/packages/extension-frontend/src/utils/getProductKey.ts
const $aa4d6d606cb06528$var$SPECIAL_HOST_PRODUCT_KEYS = {
    'calendar.google.com': 'google-calendar',
    'drive.google.com': 'GoogleDrive',
    'docs.google.com': 'GoogleDrive',
    'mail.google.com': 'gmail',
    'teams.microsoft.com': 'Microsoft',
    'outlook.com': 'outlook-mail',
    'outlook.office.com': 'outlook-mail',
    'home.atlassian.com': 'townsquare',
    'xd.adobe.com': 'adobexd',
    'community.atlassian.com': 'atlassian-web-crawler',
    'support.atlassian.com': 'Atlassian Support'
};
const $aa4d6d606cb06528$var$ATLASSIAN_DOMAIN_SUFFIXES = [
    '.atlassian.net',
    '.atlassian.cloud',
    '.jira-dev.com'
];
const $aa4d6d606cb06528$var$ATLASSIAN_PATH_PRODUCT_KEYS = {
    '/wiki': 'Confluence',
    '/browse': 'Jira',
    '/jira': 'Jira',
    '/compass': 'Compass',
    '/focus': 'Mercury'
};
const $aa4d6d606cb06528$var$DOMAIN_SUFFIX_OVERRIDES = {
    '.powerbi.com': 'power-bi',
    '.azure.com': 'azure-devops',
    '.adobesign.com': 'adobe-sign'
};
const $aa4d6d606cb06528$var$VALID_PRODUCT_KEYS = new Set([
    'bitbucket',
    'compass',
    'confluence',
    'jira',
    'jira-product-discovery',
    'jira-servicedesk',
    'trello',
    'mercury',
    'slack',
    'figma',
    'drive',
    'sharepoint',
    'onedrive',
    'dropbox',
    'github',
    'gitlab',
    'google-calendar',
    'gmail',
    'outlook-mail',
    'outlook-calendar',
    'teams',
    'zendesk',
    'airtable',
    'asana',
    'smartsheet',
    'notion',
    'miro',
    'docusign',
    'lucid',
    'monday',
    'azure-devops',
    'box',
    'zeplin',
    'servicenow',
    'power-bi',
    'clickup',
    'amplitude',
    'stripe',
    'adobexd',
    'aha',
    'mural',
    'webex',
    'todoist',
    'pagerduty',
    'pipedrive',
    'hubspot',
    'dovetail',
    'launchdarkly',
    'salesforce',
    'sentry',
    'loom',
    'adobe-sign'
]);
function $aa4d6d606cb06528$var$getProductKeyFromDomain(hostname) {
    // extract domain suffix and check if it maps to a valid product key
    const domainParts = hostname.split('.');
    if (domainParts.length >= 2) {
        const suffix = '.' + domainParts.slice(-2).join('.');
        if ($aa4d6d606cb06528$var$DOMAIN_SUFFIX_OVERRIDES[suffix]) return $aa4d6d606cb06528$var$DOMAIN_SUFFIX_OVERRIDES[suffix];
        // extract the main domain part (e.g. "zendesk" from "zendesk.com")
        const mainDomain = domainParts[domainParts.length - 2];
        // check if the main domain is a valid product key
        if ($aa4d6d606cb06528$var$VALID_PRODUCT_KEYS.has(mainDomain)) return mainDomain.split('-').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        return 'Unknown';
    }
    return 'Unknown';
}
function $aa4d6d606cb06528$export$d0b7f02493f85477(url) {
    const { hostname: hostname, pathname: pathname } = new URL(url);
    // check for special hostname mappings (e.g. calendar.google.com → google-calendar)
    if ($aa4d6d606cb06528$var$SPECIAL_HOST_PRODUCT_KEYS[hostname]) return $aa4d6d606cb06528$var$SPECIAL_HOST_PRODUCT_KEYS[hostname];
    // check if it's an Atlassian domain (e.g. company.atlassian.net)
    const isAtlassianDomain = $aa4d6d606cb06528$var$ATLASSIAN_DOMAIN_SUFFIXES.some((suffix)=>hostname.endsWith(suffix)) || hostname.includes('.atlassian.');
    if (isAtlassianDomain) {
        // for Atlassian domains, identify product based on path patterns (e.g. /wiki → confluence)
        for (const [pathPattern, productKey] of Object.entries($aa4d6d606cb06528$var$ATLASSIAN_PATH_PRODUCT_KEYS)){
            if (pathname.includes(pathPattern)) return productKey;
        }
        return 'Unknown';
    }
    // for other domains, extract product key from domain name (e.g. zendesk.com → zendesk)
    return $aa4d6d606cb06528$var$getProductKeyFromDomain(hostname);
}
module.exports["getProductKey"] = $aa4d6d606cb06528$export$d0b7f02493f85477;

});

parcelRegister("W5g3o", function(module, exports) {

var $4Tg3t = parcelRequire("4Tg3t");

const $9042266756084a97$export$b3c6d7a1ecb4efe1 = (error, commonAttributes)=>{
    const { extraAttributes: extraAttributes, source: source } = commonAttributes;
    return {
        action: 'failed',
        actionSubject: 'aiPrecomputedDefinitionFetch',
        source: source,
        eventType: 'track',
        attributes: {
            ...(0, $4Tg3t.sanitizeExtraAttributes)(extraAttributes),
            errorName: error instanceof Object && 'name' in error ? error.name : '',
            errorMessage: error instanceof Object && 'message' in error ? error.message : '',
            errorStack: error instanceof Object && 'stack' in error && typeof error.stack === 'string' ? error.stack?.split('\n').at(1) : ''
        }
    };
};
module.exports["fetchPrecomputedDefinitionErrorPayload"] = $9042266756084a97$export$b3c6d7a1ecb4efe1;

});

parcelRegister("ejlPj", function(module, exports) {
// query to check whether curated definition exists
const $663f31c0647b8bde$export$9051e5c888508a3d = 'CuratedDefinitionQuery';
const $663f31c0647b8bde$export$1886f34f107a0451 = `
query ${$663f31c0647b8bde$export$9051e5c888508a3d}(
		$workspaceId: String!
		$keyPhrase: String!
		$confluenceScopeId: KnowledgeDiscoveryDefinitionScopeIdConfluence
		$jiraScopeId: KnowledgeDiscoveryDefinitionScopeIdJira
	) {
		knowledgeDiscovery {
			definition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				confluenceScopeId: $confluenceScopeId
				jiraScopeId: $jiraScopeId
			) @optIn(to: "KnowledgeDiscovery Get definition") {
				__typename
				... on KnowledgeDiscoveryDefinition {
					definition
					accountId
					createdAt
					editor {
						... on User {
							name
							accountId
						}
					}
					referenceUrl
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
						}
					}
				}
				... on QueryError {
					message
				}
			}
		}
	}
`;
module.exports["CURATED_DEFINITION_OPERATION_NAME"] = $663f31c0647b8bde$export$9051e5c888508a3d;
module.exports["CuratedDefinitionQuery"] = $663f31c0647b8bde$export$1886f34f107a0451;

});

parcelRegister("j1YGG", function(module, exports) {
const $0b7765a5ad679bd9$export$73cd67d787c37f2e = `
query PrecomputedDefinitionQuery(
		$workspaceId: String!
		$keyPhrase: String!
        $contentId: String!
	) {
		knowledgeDiscovery {
			autoDefinition(
				workspaceId: $workspaceId
				keyPhrase: $keyPhrase
				contentId: $contentId
			) @optIn(to: "KnowledgeDiscovery Get auto definition") {
				__typename
				... on KnowledgeDiscoveryAutoDefinition {
					definition
                    createdAt
					confluenceEntity {
						... on ConfluencePage {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
						... on ConfluenceBlogPost {
							id
							type
							title
							space {
								name
							}
                            links {
                                base
                                webUi
                            }
						}
					}
				}
				... on QueryError {
					message
                    extensions {
                        statusCode
                        errorType
                    }
				}
			}
		}
	}
`;
module.exports["PrecomputedDefinitionQuery"] = $0b7765a5ad679bd9$export$73cd67d787c37f2e;

});

parcelRegister("97lMo", function(module, exports) {

var $9u8Y2 = parcelRequire("9u8Y2");


var $hpFQM = parcelRequire("hpFQM");

const $5223057167adf139$export$faaccabd846a199 = (definition)=>{
    const definitionReference = definition.confluenceEntity;
    return {
        nlpResult: definition.definition,
        uniqueSources: definitionReference ? [
            {
                id: definitionReference?.id || '',
                title: definitionReference?.title || '',
                url: 'referenceUrl' in definition ? definition.referenceUrl || '' : 'links' in definitionReference && definitionReference.links.base && definitionReference.links.webUi ? `${definitionReference.links.base}${definitionReference.links.webUi}` : '',
                type: definitionReference?.type || '',
                // Currently curated and precomputed definitions sources can only be Confluence
                product: 'Confluence',
                lastModified: '',
                iconUrl: '',
                spaceName: definitionReference?.space?.name || '',
                spaceUrl: null
            }
        ] : [],
        nlpResultEditor: 'editor' in definition ? {
            name: definition.editor?.name || '',
            id: definition.editor?.accountId || ''
        } : undefined,
        disclaimer: null,
        errorState: null,
        format: (0, $hpFQM.NLPSearchResultFormat).MARKDOWN,
        customDefinitionType: 'editor' in definition ? (0, $9u8Y2.NLPSearchCustomDefinitionType).CURATED : (0, $9u8Y2.NLPSearchCustomDefinitionType).PRECOMPUTED
    };
};
module.exports["mapCustomDefinitionToNLPSearchType"] = $5223057167adf139$export$faaccabd846a199;

});

parcelRegister("9u8Y2", function(module, exports) {
var $087ad2b4edc49da7$export$12b805d25b464b8d = /*#__PURE__*/ function(NLPSearchCustomDefinitionType) {
    NLPSearchCustomDefinitionType["CURATED"] = "CURATED";
    NLPSearchCustomDefinitionType["PRECOMPUTED"] = "PRECOMPUTED";
    return NLPSearchCustomDefinitionType;
}({});
module.exports["NLPSearchCustomDefinitionType"] = $087ad2b4edc49da7$export$12b805d25b464b8d;

});

parcelRegister("djTZ8", function(module, exports) {
/* definition-popup.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $4n1IT = parcelRequire("4n1IT");


var $4o0zT = parcelRequire("4o0zT");

const $c5082a2841defa60$var$DEFINITION_DIALOG_TITLE_ID = 'definition-dialog-title';
const $c5082a2841defa60$var$popupContainerStyles = null;
const $c5082a2841defa60$var$CustomPopupContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, ...props }, ref)=>{
    if ((0, $4o0zT.isExperimentEnabled)('a11y-fixes-week1-june-2026')) return /*#__PURE__*/ $cozmU.createElement("div", {
        ...props,
        ref: ref,
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": $c5082a2841defa60$var$DEFINITION_DIALOG_TITLE_ID,
        className: (0, $hekY6.default)([
            "_42Yu6BPvK5"
        ])
    }, children);
    return /*#__PURE__*/ $cozmU.createElement("span", {
        ...props,
        ref: ref,
        className: (0, $hekY6.default)([
            "_42Yu6BPvK5"
        ])
    }, children);
});
const $c5082a2841defa60$var$definitionPopupTriggerStylesStatic = null;

const $c5082a2841defa60$var$LazyDefinitionPopupContent = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eQ7jU")).then((module)=>({
            default: module.DefinitionPopupContent
        })));
function $c5082a2841defa60$export$576a6d4c65a0c923({ onClose: onClose, triggerPosition: triggerPosition, onLoad: onLoad, ...definitionPopupContentProps }) {
    const definitionPopupTriggerStylesDynamic = {
        height: `${triggerPosition.height}px`,
        left: `${triggerPosition.left}px`,
        top: `${triggerPosition.top}px`,
        width: `${triggerPosition.width}px`
    };
    return /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
        content: ({ update: update })=>/*#__PURE__*/ $cozmU.createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ $cozmU.createElement($c5082a2841defa60$var$LazyDefinitionPopupContent, {
                ...definitionPopupContentProps,
                onClose: onClose,
                onLoad: ()=>{
                    onLoad?.();
                    update();
                }
            })),
        onClose: onClose,
        placement: "bottom-start",
        popupComponent: $c5082a2841defa60$var$CustomPopupContainer,
        testId: "definition-popup",
        trigger: (triggerProps)=>/*#__PURE__*/ $cozmU.createElement("span", {
                ...triggerProps,
                style: definitionPopupTriggerStylesDynamic,
                "data-testid": "definition-popup-trigger",
                className: (0, $hekY6.default)([
                    "_1YKVNsdnbC _1mT5xdWVPG _1pp6NdYbGa _0KLXrujOvk _3OE6xYdnbC _0Bm75GdnbC"
                ])
            }),
        isOpen: true
    });
}
module.exports["DefinitionPopup"] = $c5082a2841defa60$export$576a6d4c65a0c923;

});

parcelRegister("eQ7jU", function(module, exports) {

let $acdb99a90a35fa3f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $acdb99a90a35fa3f$var$load("7qZ5n"),
    $acdb99a90a35fa3f$var$load("gnalD"),
    $acdb99a90a35fa3f$var$load("kA7hu"),
    $acdb99a90a35fa3f$var$load("hvxe4"),
    $acdb99a90a35fa3f$var$load("60QcS"),
    $acdb99a90a35fa3f$var$load("74aY4"),
    $acdb99a90a35fa3f$var$load("ht9Ko"),
    $acdb99a90a35fa3f$var$load("hUbK8"),
    $acdb99a90a35fa3f$var$load("gIig2"),
    $acdb99a90a35fa3f$var$load("5KHgm"),
    $acdb99a90a35fa3f$var$load("fcAaN"),
    $acdb99a90a35fa3f$var$load("6uAgO"),
    $acdb99a90a35fa3f$var$load("3i6cl"),
    $acdb99a90a35fa3f$var$load("lpIpZ"),
    $acdb99a90a35fa3f$var$load("1Gr4q"),
    $acdb99a90a35fa3f$var$load("bX3Av"),
    $acdb99a90a35fa3f$var$load("hLNtE"),
    $acdb99a90a35fa3f$var$load("crwC4"),
    $acdb99a90a35fa3f$var$load("kccW9"),
    $acdb99a90a35fa3f$var$load("iPvQ1"),
    $acdb99a90a35fa3f$var$load("8yk9S"),
    $acdb99a90a35fa3f$var$load("iOfkQ"),
    $acdb99a90a35fa3f$var$load("eeYoU"),
    $acdb99a90a35fa3f$var$load("do0Fh"),
    $acdb99a90a35fa3f$var$load("fEHF5"),
    $acdb99a90a35fa3f$var$load("4XoWv"),
    $acdb99a90a35fa3f$var$load("2PVCX"),
    $acdb99a90a35fa3f$var$load("cyTuQ"),
    $acdb99a90a35fa3f$var$load("jqoep"),
    $acdb99a90a35fa3f$var$load("6wr18"),
    $acdb99a90a35fa3f$var$load("59hV4"),
    $acdb99a90a35fa3f$var$load("8T2wY"),
    $acdb99a90a35fa3f$var$load("cKj6g"),
    $acdb99a90a35fa3f$var$load("6PtAo"),
    $acdb99a90a35fa3f$var$load("aMsb0"),
    $acdb99a90a35fa3f$var$load("2PXrC"),
    $acdb99a90a35fa3f$var$load("h1yOv"),
    $acdb99a90a35fa3f$var$load("aLwQm"),
    $acdb99a90a35fa3f$var$load("3g5Gh"),
    $acdb99a90a35fa3f$var$load("eIINb"),
    $acdb99a90a35fa3f$var$load("eqj21"),
    $acdb99a90a35fa3f$var$load("3oAU3"),
    $acdb99a90a35fa3f$var$load("a8glC"),
    $acdb99a90a35fa3f$var$load("bg4Qo"),
    $acdb99a90a35fa3f$var$load("ccAQf"),
    $acdb99a90a35fa3f$var$load("4x9Jx"),
    $acdb99a90a35fa3f$var$load("Wowvf"),
    $acdb99a90a35fa3f$var$load("hhss7"),
    $acdb99a90a35fa3f$var$load("by9qp"),
    $acdb99a90a35fa3f$var$load("i6gwF"),
    $acdb99a90a35fa3f$var$load("6bjEk"),
    $acdb99a90a35fa3f$var$load("ffEVr"),
    $acdb99a90a35fa3f$var$load("bk398"),
    $acdb99a90a35fa3f$var$load("fHiQ2"),
    $acdb99a90a35fa3f$var$load("dOLuJ"),
    $acdb99a90a35fa3f$var$load("aAWLw"),
    $acdb99a90a35fa3f$var$load("7EorR"),
    $acdb99a90a35fa3f$var$load("lyDkU")
]).then(()=>parcelRequire('lPV0U'));

});

parcelRegister("jkdKe", function(module, exports) {
var $8ca9ab19b77d9d33$export$a53c998f5fa685e1 = /*#__PURE__*/ function(EditedDefinitionScope) {
    EditedDefinitionScope["SPACE"] = "SPACE";
    EditedDefinitionScope["PAGE"] = "PAGE";
    EditedDefinitionScope["BLOGPOST"] = "BLOGPOST";
    EditedDefinitionScope["ORGANIZATION"] = "ORGANIZATION";
    EditedDefinitionScope["PROJECT"] = "PROJECT";
    return EditedDefinitionScope;
}({});
module.exports["EditedDefinitionScope"] = $8ca9ab19b77d9d33$export$a53c998f5fa685e1;

});

parcelRegister("97Szk", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kkFbH = parcelRequire("kkFbH");


var $8A5sV = parcelRequire("8A5sV");


var $kpuvJ = parcelRequire("kpuvJ");


var $d4GYd = parcelRequire("d4GYd");


var $jkdKe = parcelRequire("jkdKe");

const $3fda69966c9a64cd$var$i18n = (0, $kSwu1.defineMessages)({
    editDefinitionRestrictedToSpaceOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.space.option",
        defaultMessage: "In this space"
    },
    editDefinitionRestrictedToPageOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.page.option",
        defaultMessage: "On this page"
    },
    editDefinitionRestrictedToBlogpostOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.blogpost.option",
        defaultMessage: "On this blogpost"
    },
    editDefinitionRestrictedToSiteOption: {
        id: "contextual-reading-aids.edit.definition.restricted.to.site.option",
        defaultMessage: "On this site"
    }
});
function $3fda69966c9a64cd$export$ad09b24d617a41f5(contentType) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>[
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSpaceOption),
                value: (0, $jkdKe.EditedDefinitionScope).SPACE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8A5sV))), {
                    label: ""
                })
            },
            contentType === 'blogpost' ? {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToBlogpostOption),
                value: (0, $jkdKe.EditedDefinitionScope).BLOGPOST,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))), {
                    label: ""
                })
            } : {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToPageOption),
                value: (0, $jkdKe.EditedDefinitionScope).PAGE,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                    label: ""
                })
            },
            {
                label: formatMessage($3fda69966c9a64cd$var$i18n.editDefinitionRestrictedToSiteOption),
                value: (0, $jkdKe.EditedDefinitionScope).ORGANIZATION,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kpuvJ))), {
                    label: ""
                })
            }
        ], [
        contentType,
        formatMessage
    ]);
}
module.exports["useDefinitionRestrictionOptions"] = $3fda69966c9a64cd$export$ad09b24d617a41f5;

});


//# sourceMappingURL=sha256SimpleHasher.994a340f.js.map
